var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLuke(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 679 567",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Platforma_ALL",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ALL---3.5---Final-End",
    transform: "translate(-774.000000, -98.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-7-Copy",
    transform: "translate(774.000000, 99.000000)"
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "Stroke-1",
    stroke: "#1D1D1B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    points: "153.2651 544.185023 291.0551 544.185023 297.0551 544.185023 346.9651 544.185023 355.3751 544.185023 493.4151 544.185023"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M509.4038,270.730023 C509.4038,376.047023 424.0268,461.424023 318.7088,461.424023 C213.3908,461.424023 128.0128,376.047023 128.0128,270.730023 C128.0128,165.412023 213.3908,80.0350232 318.7088,80.0350232 C424.0268,80.0350232 509.4038,165.412023 509.4038,270.730023",
    id: "Fill-2",
    fill: "#E7ECFE"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 107.8296,
    y1: 232.487823,
    x2: 53.8116,
    y2: 227.264823,
    id: "Stroke-4",
    stroke: "#F7A800"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 470.2573,
    y1: 193.628423,
    x2: 520.9323,
    y2: 174.205423,
    id: "Stroke-5",
    stroke: "#1D1D1B",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 530.3227,
    y1: 354.674323,
    x2: 480.8647,
    y2: 332.333323,
    id: "Stroke-6",
    stroke: "#1D1D1B",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 518.4379,
    y1: 434.070823,
    x2: 478.1279,
    y2: 397.735823,
    id: "Stroke-7",
    stroke: "#F7A800"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 461.0795,
    y1: 52.2182232,
    x2: 429.2985,
    y2: 96.2082232,
    id: "Stroke-8",
    stroke: "#F7A800"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 166.3159,
    y1: 193.628423,
    x2: 115.6409,
    y2: 174.205423,
    id: "Stroke-9",
    stroke: "#1D1D1B",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 196.8227,
    y1: 169.203623,
    x2: 152.9407,
    y2: 137.273623,
    id: "Stroke-10",
    stroke: "#1D1D1B",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 175.4936,
    y1: 52.2182232,
    x2: 207.2746,
    y2: 96.2082232,
    id: "Stroke-11",
    stroke: "#1D1D1B",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 188.1606,
    y1: 394.919423,
    x2: 149.7866,
    y2: 433.294423,
    id: "Stroke-12",
    stroke: "#1D1D1B",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 98.5053,
    y1: 363.347223,
    x2: 50.1063,
    y2: 387.896223,
    id: "Stroke-13",
    stroke: "#1D1D1B",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 645.6655,
    y1: 231.065923,
    x2: 591.5145,
    y2: 234.642923,
    id: "Stroke-14",
    stroke: "#1D1D1B",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M583.6391,115.425323 C584.5421,116.063323 585.1321,117.115323 585.1321,118.305323 C585.1321,118.658323 585.0791,118.998323 584.9831,119.321323 C584.6941,120.289323 583.9981,121.083323 583.0951,121.504323 C582.7991,121.644323 582.4791,121.742323 582.1441,121.793323 C581.9681,121.821323 581.7881,121.835323 581.6051,121.835323 C579.6561,121.835323 578.0751,120.254323 578.0751,118.305323 C578.0751,116.857323 578.9501,115.612323 580.2001,115.070323 C580.6161,114.888323 581.0761,114.784323 581.5581,114.780323 C581.5741,114.779323 581.5891,114.779323 581.6051,114.779323 C582.3631,114.779323 583.0651,115.017323 583.6391,115.425323",
    id: "Fill-15",
    fill: "#85A1F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.563,109.693823 C6.466,110.331823 7.056,111.382823 7.056,112.573823 C7.056,112.926823 7.003,113.266823 6.907,113.589823 C6.618,114.557823 5.922,115.351823 5.019,115.772823 C4.723,115.912823 4.404,116.010823 4.068,116.061823 C3.892,116.089823 3.712,116.103823 3.529,116.103823 C1.58,116.103823 1.99840144e-14,114.522823 1.99840144e-14,112.573823 C1.99840144e-14,111.125823 0.874,109.880823 2.124,109.338823 C2.54,109.156823 3,109.052823 3.483,109.048823 C3.498,109.046823 3.513,109.046823 3.529,109.046823 C4.288,109.046823 4.989,109.285823 5.563,109.693823",
    id: "Fill-17",
    fill: "#85A1F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.9497,404.532723 C130.4017,404.850723 130.6967,405.377723 130.6967,405.971723 C130.6967,406.148723 130.6707,406.318723 130.6217,406.479723 C130.4767,406.964723 130.1297,407.361723 129.6787,407.571723 C129.5297,407.641723 129.3697,407.690723 129.2027,407.716723 C129.1147,407.730723 129.0247,407.737723 128.9327,407.737723 C127.9587,407.737723 127.1677,406.946723 127.1677,405.971723 C127.1677,405.248723 127.6047,404.625723 128.2297,404.354723 C128.4377,404.263723 128.6687,404.212723 128.9097,404.210723 C128.9177,404.209723 128.9257,404.209723 128.9327,404.209723 C129.3117,404.209723 129.6627,404.328723 129.9497,404.532723",
    id: "Fill-19",
    fill: "#1D1D1B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.0483,39.9087232 C222.9513,40.5467232 223.5413,41.5977232 223.5413,42.7887232 C223.5413,43.1417232 223.4883,43.4817232 223.3923,43.8047232 C223.1033,44.7727232 222.4073,45.5657232 221.5043,45.9867232 C221.2083,46.1277232 220.8883,46.2257232 220.5533,46.2767232 C220.3773,46.3047232 220.1973,46.3177232 220.0143,46.3177232 C218.0653,46.3177232 216.4853,44.7377232 216.4853,42.7887232 C216.4853,41.3397232 217.3593,40.0947232 218.6093,39.5537232 C219.0253,39.3717232 219.4853,39.2677232 219.9683,39.2637232 C219.9833,39.2617232 219.9983,39.2617232 220.0143,39.2617232 C220.7723,39.2617232 221.4743,39.5007232 222.0483,39.9087232",
    id: "Fill-21",
    fill: "#1D1D1B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M670.5971,435.855023 C671.1131,436.219023 671.4491,436.820023 671.4491,437.500023 C671.4491,437.701023 671.4191,437.894023 671.3641,438.079023 C671.1991,438.631023 670.8021,439.084023 670.2861,439.325023 C670.1181,439.405023 669.9351,439.461023 669.7431,439.490023 C669.6441,439.506023 669.5411,439.513023 669.4361,439.513023 C668.3241,439.513023 667.4211,438.612023 667.4211,437.500023 C667.4211,436.672023 667.9201,435.961023 668.6341,435.652023 C668.8711,435.548023 669.1341,435.490023 669.4101,435.487023 C669.4181,435.486023 669.4271,435.486023 669.4361,435.486023 C669.8681,435.486023 670.2691,435.623023 670.5971,435.855023",
    id: "Fill-23",
    fill: "#1D1D1B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.1069,228.805223 C194.8419,230.860223 192.9609,232.315223 190.9019,232.050223 C188.8469,231.784223 187.3969,229.900223 187.6619,227.845223 C187.9269,225.789223 189.8069,224.340223 191.8619,224.605223 C193.9209,224.869223 195.3719,226.749223 195.1069,228.805223",
    id: "Fill-25",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.1069,228.805223 C194.8419,230.860223 192.9609,232.315223 190.9019,232.050223 C188.8469,231.784223 187.3969,229.900223 187.6619,227.845223 C187.9269,225.789223 189.8069,224.340223 191.8619,224.605223 C193.9209,224.869223 195.3719,226.749223 195.1069,228.805223 Z",
    id: "Stroke-27",
    stroke: "#1D1D1B",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.7514,32.7095232 C81.2214,36.8185232 77.4614,39.7295232 73.3414,39.1995232 C69.2304,38.6695232 66.3304,34.8985232 66.8604,30.7895232 C67.3914,26.6795232 71.1504,23.7785232 75.2614,24.3095232 C79.3814,24.8395232 82.2804,28.5995232 81.7514,32.7095232 Z",
    id: "Stroke-29",
    stroke: "#1D1D1B",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M669.2348,23.9878232 C665.4878,21.3278232 660.9108,19.7678232 655.9618,19.7678232 C655.8608,19.7678232 655.7608,19.7678232 655.6608,19.7828232 C652.5138,19.8108232 649.5098,20.4838232 646.7928,21.6718232 C638.6398,25.2038232 632.9328,33.3288232 632.9328,42.7828232 C632.9328,55.4988232 643.2458,65.8108232 655.9618,65.8108232 C657.1628,65.8108232 658.3358,65.7248232 659.4798,65.5398232 C661.6688,65.2108232 663.7558,64.5668232 665.6878,63.6518232 C671.5808,60.9048232 676.1148,55.7278232 678.0038,49.4048232 C678.6318,47.3018232 678.9748,45.0868232 678.9748,42.7828232 C678.9748,35.0158232 675.1288,28.1498232 669.2348,23.9878232",
    id: "Fill-31",
    fill: "#FFF6E7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.8296,307.546423 C135.5016,308.602423 134.6826,309.487423 133.5496,309.855423 C133.2136,309.963423 132.8746,310.018423 132.5376,310.026423 C131.5266,310.048423 130.5586,309.632423 129.8796,308.902423 C129.6546,308.664423 129.4616,308.390423 129.3106,308.086423 C129.2286,307.928423 129.1616,307.761423 129.1046,307.586423 C128.5046,305.732423 129.5206,303.741423 131.3746,303.141423 C132.7536,302.694423 134.2076,303.143423 135.1076,304.164423 C135.4096,304.505423 135.6486,304.911423 135.8026,305.368423 C135.8086,305.382423 135.8126,305.397423 135.8176,305.411423 C136.0526,306.133423 136.0406,306.874423 135.8296,307.546423",
    id: "Fill-33",
    fill: "#F7A800"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M531.4077,216.481923 L523.7667,216.481923 L523.7667,217.896923 C512.7157,222.074923 504.6527,235.073923 504.6527,250.471923 C504.6527,265.870923 512.7157,278.870923 523.7667,283.047923 L523.7667,284.461923 L531.4077,284.461923 C546.1837,284.461923 558.1627,269.244923 558.1627,250.471923 C558.1627,231.699923 546.1837,216.481923 531.4077,216.481923",
    id: "Fill-35",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M531.4077,216.481923 L523.7667,216.481923 L523.7667,217.896923 C512.7157,222.074923 504.6527,235.073923 504.6527,250.471923 C504.6527,265.870923 512.7157,278.870923 523.7667,283.047923 L523.7667,284.461923 L531.4077,284.461923 C546.1837,284.461923 558.1627,269.244923 558.1627,250.471923 C558.1627,231.699923 546.1837,216.481923 531.4077,216.481923 Z",
    id: "Stroke-37",
    stroke: "#1D1D1B",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M551.309,250.472223 C551.309,269.244223 539.33,284.462223 524.554,284.462223 C509.778,284.462223 497.799,269.244223 497.799,250.472223 C497.799,231.700223 509.778,216.482223 524.554,216.482223 C539.33,216.482223 551.309,231.700223 551.309,250.472223",
    id: "Fill-39",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M551.309,250.472223 C551.309,269.244223 539.33,284.462223 524.554,284.462223 C509.778,284.462223 497.799,269.244223 497.799,250.472223 C497.799,231.700223 509.778,216.482223 524.554,216.482223 C539.33,216.482223 551.309,231.700223 551.309,250.472223 Z",
    id: "Stroke-41",
    stroke: "#1D1D1B",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M545.6694,250.472223 C545.6694,265.287223 536.2164,277.298223 524.5544,277.298223 C512.8924,277.298223 503.4394,265.287223 503.4394,250.472223 C503.4394,235.657223 512.8924,223.647223 524.5544,223.647223 C536.2164,223.647223 545.6694,235.657223 545.6694,250.472223",
    id: "Fill-43",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M545.6694,250.472223 C545.6694,265.287223 536.2164,277.298223 524.5544,277.298223 C512.8924,277.298223 503.4394,265.287223 503.4394,250.472223 C503.4394,235.657223 512.8924,223.647223 524.5544,223.647223 C536.2164,223.647223 545.6694,235.657223 545.6694,250.472223 Z",
    id: "Stroke-45",
    stroke: "#1D1D1B",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-47",
    fill: "#FFFFFF",
    points: "522.9811 216.482323 531.4081 216.482323 531.4081 214.143323 522.9811 214.143323"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Stroke-49",
    stroke: "#1D1D1B",
    strokeWidth: 0.5,
    points: "522.9811 216.482323 531.4081 216.482323 531.4081 214.143323 522.9811 214.143323"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-50",
    fill: "#FFFFFF",
    points: "519.8671 214.143323 534.5221 214.143323 534.5221 208.919323 519.8671 208.919323"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Stroke-51",
    stroke: "#1D1D1B",
    strokeWidth: 0.5,
    points: "519.8671 214.143323 534.5221 214.143323 534.5221 208.919323 519.8671 208.919323"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-54",
    transform: "translate(523.999100, 228.299323)"
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-52",
    fill: "#FFFFFF",
    points: "0.5551 0.0957 0.5551 22.1727 16.2931 16.4247"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Stroke-53",
    stroke: "#1D1D1B",
    strokeWidth: 0.5,
    points: "0.5551 0.0957 0.5551 22.1727 16.2931 16.4247"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M72.2563,475.784723 C83.2223,483.529723 90.3813,496.305723 90.3813,510.758723 C90.3813,515.043723 89.7423,519.168723 88.5713,523.081723 C85.0583,534.845723 76.6213,544.480723 65.6553,549.590723 C62.0623,551.294723 58.1763,552.491723 54.1043,553.103723 C51.9753,553.449723 49.7923,553.609723 47.5563,553.609723 C23.8953,553.609723 4.7053,534.419723 4.7053,510.758723 C4.7053,493.165723 15.3243,478.047723 30.4953,471.472723 C35.5533,469.263723 41.1423,468.013723 46.9973,467.960723 C47.1843,467.932723 47.3703,467.932723 47.5563,467.932723 C56.7663,467.932723 65.2823,470.834723 72.2563,475.784723",
    id: "Fill-55",
    fill: "#FFF6E7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.4555,467.933123 C14.4555,469.877123 12.8805,471.453123 10.9355,471.453123 C8.9925,471.453123 7.4165,469.877123 7.4165,467.933123 C7.4165,465.990123 8.9925,464.413123 10.9355,464.413123 C12.8805,464.413123 14.4555,465.990123 14.4555,467.933123",
    id: "Fill-56",
    fill: "#F7A800"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-59",
    transform: "translate(59.999100, 479.299323)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.142,0.75 C11.142,3.605 8.819,5.929 5.963,5.929 C3.108,5.929 0.785,3.605 0.785,0.75",
    id: "Fill-57",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.142,0.75 C11.142,3.605 8.819,5.929 5.963,5.929 C3.108,5.929 0.785,3.605 0.785,0.75",
    id: "Stroke-58",
    stroke: "#1D1D1B",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M82.1997,476.366723 L82.1997,480.049723 L49.7247,480.049723 L49.7247,476.366723 C49.7247,475.054723 50.7897,473.514723 52.1017,473.514723 L52.6617,473.318723 L52.6617,462.685723 C52.6617,456.287723 56.9817,450.989723 63.0077,449.718723 C62.9937,449.621723 63.0287,449.451723 63.0287,449.354723 C63.0287,447.813723 64.4217,446.593723 65.9627,446.593723 C67.0607,446.593723 68.1207,447.212723 68.5767,448.131723 C68.7627,448.504723 68.9267,448.905723 68.9267,449.354723 C68.9267,449.451723 68.9627,449.628723 68.9487,449.724723 C70.1787,449.980723 71.1097,450.358723 72.1877,450.939723 C72.3187,451.001723 72.4507,451.070723 72.5747,451.153723 C76.5687,453.440723 79.2627,457.745723 79.2627,462.685723 L79.2627,472.989723 L79.8227,473.536723 C81.1357,473.536723 82.1997,475.054723 82.1997,476.366723",
    id: "Fill-60",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.1997,476.366723 L82.1997,480.049723 L49.7247,480.049723 L49.7247,476.366723 C49.7247,475.054723 50.7897,473.514723 52.1017,473.514723 L52.6617,473.318723 L52.6617,462.685723 C52.6617,456.287723 56.9817,450.989723 63.0077,449.718723 C62.9937,449.621723 63.0287,449.451723 63.0287,449.354723 C63.0287,447.813723 64.4217,446.593723 65.9627,446.593723 C67.0607,446.593723 68.1207,447.212723 68.5767,448.131723 C68.7627,448.504723 68.9267,448.905723 68.9267,449.354723 C68.9267,449.451723 68.9627,449.628723 68.9487,449.724723 C70.1787,449.980723 71.1097,450.358723 72.1877,450.939723 C72.3187,451.001723 72.4507,451.070723 72.5747,451.153723 C76.5687,453.440723 79.2627,457.745723 79.2627,462.685723 L79.2627,472.989723 L79.8227,473.536723 C81.1357,473.536723 82.1997,475.054723 82.1997,476.366723 Z",
    id: "Stroke-61",
    stroke: "#1D1D1B",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.1303,477.315923 C100.2123,494.246923 84.5863,506.620923 66.0693,506.620923 C43.6083,506.620923 25.3993,488.411923 25.3993,465.949923 C25.3993,443.487923 43.6083,425.278923 66.0693,425.278923 C74.0153,425.278923 81.4283,427.556923 87.6923,431.496923",
    id: "Stroke-62",
    stroke: "#1D1D1B",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.2973,435.737823 C101.5513,443.180823 106.7393,453.959823 106.7393,465.949823 C106.7393,467.324823 106.6713,468.683823 106.5383,470.023823",
    id: "Stroke-63",
    stroke: "#1D1D1B",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M511.395,107.811023 L478.308,87.0040232 C474.061,84.3330232 472.772,78.6730232 475.443,74.4260232 L519.568,4.2580232 C522.239,0.0110232046 527.899,-1.2789768 532.146,1.3920232 L565.233,22.2000232 C569.48,24.8710232 570.77,30.5300232 568.099,34.7770232 L523.973,104.945023 C521.302,109.192023 515.642,110.482023 511.395,107.811023",
    id: "Fill-64",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M511.395,107.811023 L478.308,87.0040232 C474.061,84.3330232 472.772,78.6730232 475.443,74.4260232 L519.568,4.2580232 C522.239,0.0110232046 527.899,-1.2789768 532.146,1.3920232 L565.233,22.2000232 C569.48,24.8710232 570.77,30.5300232 568.099,34.7770232 L523.973,104.945023 C521.302,109.192023 515.642,110.482023 511.395,107.811023 Z",
    id: "Stroke-65",
    stroke: "#1D1D1B",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M507.1928,105.168423 L478.3078,87.0044232 C474.0608,84.3334232 472.7718,78.6734232 475.4428,74.4264232 L519.5678,4.2584232 C522.2388,0.0114232046 527.8988,-1.2785768 532.1458,1.3924232 L561.0308,19.5574232 C565.2778,22.2284232 566.5678,27.8884232 563.8968,32.1354232 L519.7708,102.302423 C517.0998,106.549423 511.4398,107.839423 507.1928,105.168423",
    id: "Fill-66",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M507.1928,105.168423 L478.3078,87.0044232 C474.0608,84.3334232 472.7718,78.6734232 475.4428,74.4264232 L519.5678,4.2584232 C522.2388,0.0114232046 527.8988,-1.2785768 532.1458,1.3924232 L561.0308,19.5574232 C565.2778,22.2284232 566.5678,27.8884232 563.8968,32.1354232 L519.7708,102.302423 C517.0998,106.549423 511.4398,107.839423 507.1928,105.168423 Z",
    id: "Stroke-67",
    stroke: "#1D1D1B",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M508.8227,102.951623 L479.5997,84.5746232 C476.8727,82.8596232 476.0447,79.2246232 477.7597,76.4976232 L522.4387,5.4496232 C524.1537,2.7226232 527.7887,1.8936232 530.5157,3.6086232 L559.7397,21.9856232 C562.4677,23.7016232 563.2957,27.3366232 561.5797,30.0636232 L516.8997,101.111623 C515.1847,103.839623 511.5507,104.667623 508.8227,102.951623",
    id: "Fill-68",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M508.8227,102.951623 L479.5997,84.5746232 C476.8727,82.8596232 476.0447,79.2246232 477.7597,76.4976232 L522.4387,5.4496232 C524.1537,2.7226232 527.7887,1.8936232 530.5157,3.6086232 L559.7397,21.9856232 C562.4677,23.7016232 563.2957,27.3366232 561.5797,30.0636232 L516.8997,101.111623 C515.1847,103.839623 511.5507,104.667623 508.8227,102.951623 Z",
    id: "Stroke-69",
    stroke: "#1D1D1B",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-72",
    transform: "translate(540.999100, 10.299323)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.4154,4.1641 L5.1354,5.4441 C4.8044,5.6301 4.3984,5.6191 4.0774,5.4181 L1.3794,3.7211 C1.0584,3.5181 0.8734,3.1571 0.8964,2.7791 L1.0624,0.1691",
    id: "Fill-70",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.4154,4.1641 L5.1354,5.4441 C4.8044,5.6301 4.3984,5.6191 4.0774,5.4181 L1.3794,3.7211 C1.0584,3.5181 0.8734,3.1571 0.8964,2.7791 L1.0624,0.1691",
    id: "Stroke-71",
    stroke: "#1D1D1B",
    strokeWidth: 0.5
  })), /*#__PURE__*/React.createElement("path", {
    d: "M544.8168,13.2807232 L544.6858,13.1987232 C544.5468,13.1117232 544.5048,12.9267232 544.5928,12.7887232 L544.6738,12.6577232 C544.7618,12.5187232 544.9468,12.4767232 545.0858,12.5637232 L545.2148,12.6457232 C545.3538,12.7337232 545.3968,12.9187232 545.3088,13.0567232 L545.2268,13.1867232 C545.1398,13.3257232 544.9558,13.3677232 544.8168,13.2807232",
    id: "Fill-73",
    fill: "#FAEFE8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M544.8168,13.2807232 L544.6858,13.1987232 C544.5468,13.1117232 544.5048,12.9267232 544.5928,12.7887232 L544.6738,12.6577232 C544.7618,12.5187232 544.9468,12.4767232 545.0858,12.5637232 L545.2148,12.6457232 C545.3538,12.7337232 545.3968,12.9187232 545.3088,13.0567232 L545.2268,13.1867232 C545.1398,13.3257232 544.9558,13.3677232 544.8168,13.2807232 Z",
    id: "Stroke-74",
    stroke: "#1D1D1B",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-75",
    fill: "#FFF6E7",
    points: "545.8891 55.0141232 491.4491 54.7291232 502.6561 36.9081232 557.0971 37.1931232"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-76",
    fill: "#FFF6E7",
    points: "540.144 64.1509232 485.704 63.8659232 489.179 58.3389232 543.62 58.6239232"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 503.8305,
    y1: 35.0405232,
    x2: 484.2555,
    y2: 66.1675232,
    id: "Stroke-77",
    stroke: "#1D1D1B",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 559.018,
    y1: 34.1372232,
    x2: 535.937,
    y2: 70.8402232,
    id: "Stroke-78",
    stroke: "#1D1D1B",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.7172,312.951723 C377.7172,312.951723 399.0122,317.261723 408.1372,333.118723 L411.3182,331.260723 C411.3182,331.260723 397.9422,314.269723 377.7172,312.951723",
    id: "Fill-79",
    fill: "#1D1D1B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.8833,307.711423 C396.7803,310.039423 409.2323,316.110423 417.8913,327.975423",
    id: "Stroke-80",
    stroke: "#1D1D1B",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.5346,458.875523 C379.9336,430.525523 371.8246,387.555523 354.4246,368.945523 C354.4246,368.945523 348.9046,363.075523 346.7636,360.605523 C352.1836,358.385523 357.9546,359.775523 363.3536,367.155523 C367.8536,373.295523 390.4946,409.905523 370.7946,457.015523 C370.5136,457.686523 370.2446,458.365523 370.0046,459.055523 L369.5346,458.875523 Z",
    id: "Fill-81",
    fill: "#708BE6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.5043,456.226123 C366.8543,449.795123 364.6143,443.885123 360.4833,443.015123 C356.3643,442.146123 351.9243,446.646123 350.5643,453.076123 C349.2143,459.496123 351.4543,465.406123 355.5843,466.276123 C359.7043,467.146123 364.1443,462.646123 365.5043,456.226123 M354.4243,368.946123 C371.8243,387.555123 379.9343,430.526123 369.5343,458.875123 L370.0043,459.055123 C368.5243,463.165123 367.7243,467.455123 368.2143,471.805123 C369.0043,478.885123 369.9943,487.915123 366.8143,504.165123 L335.5243,507.436123 C335.0543,505.736123 334.6843,504.045123 334.3843,502.366123 C336.2043,499.686123 341.0143,482.856123 341.2443,475.576123 C341.3943,470.515123 340.5143,463.595123 338.9833,457.316123 C337.4643,451.045123 328.4243,433.425123 327.4143,414.326123 C326.3943,395.236123 328.6943,388.515123 328.6943,388.515123 C328.6943,388.515123 332.4143,374.366123 338.1743,367.215123 C340.8443,364.165123 343.7543,361.835123 346.7643,360.606123 C348.9043,363.076123 354.4243,368.946123 354.4243,368.946123",
    id: "Fill-82",
    fill: "#85A1F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.4838,443.015123 C364.6148,443.885123 366.8538,449.795123 365.5048,456.226123 C364.1438,462.646123 359.7048,467.146123 355.5848,466.276123 C351.4548,465.406123 349.2138,459.495123 350.5638,453.076123 C351.9238,446.646123 356.3648,442.146123 360.4838,443.015123",
    id: "Fill-83",
    fill: "#85A1F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.6948,388.515123 C328.6948,388.515123 326.3938,395.236123 327.4148,414.326123 C328.4238,433.425123 337.4648,451.045123 338.9838,457.316123 C340.5138,463.595123 341.3938,470.515123 341.2448,475.576123 C341.0138,482.856123 336.2048,499.686123 334.3838,502.366123 C332.6648,492.646123 333.5238,483.425123 334.1738,476.245123 C335.0238,466.745123 332.8248,457.765123 329.8538,448.705123 C319.4948,417.085123 325.2148,392.476123 326.5238,388.555123 C329.1248,380.755123 333.2638,372.795123 338.1738,367.215123 C332.4148,374.366123 328.6948,388.515123 328.6948,388.515123",
    id: "Fill-84",
    fill: "#708BE6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.5239,507.436023 C335.0539,505.736023 334.6839,504.045023 334.3839,502.366023 C332.6649,492.646023 333.5239,483.425023 334.1739,476.246023 C335.0239,466.746023 332.8249,457.765023 329.8539,448.706023 C319.4949,417.085023 325.2139,392.476023 326.5239,388.555023 C329.1249,380.755023 333.2639,372.795023 338.1739,367.215023 C340.8439,364.166023 343.7539,361.835023 346.7639,360.606023 C352.1839,358.385023 357.9549,359.776023 363.3539,367.156023 C367.8539,373.295023 390.4949,409.906023 370.7949,457.015023 C370.5139,457.686023 370.2449,458.366023 370.0039,459.055023 C368.5239,463.165023 367.7239,467.456023 368.2139,471.805023 C369.0039,478.885023 369.9949,487.915023 366.8139,504.165023",
    id: "Stroke-85",
    stroke: "#1D1D1B",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.5639,453.075723 C349.2139,459.495723 351.4549,465.405723 355.5849,466.275723 C359.7049,467.145723 364.1439,462.645723 365.5039,456.225723 C366.8539,449.795723 364.6149,443.885723 360.4839,443.014723 C356.3649,442.145723 351.9239,446.645723 350.5639,453.075723 Z",
    id: "Stroke-86",
    stroke: "#1D1D1B",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.5346,458.875523 C379.9336,430.525523 371.8246,387.555523 354.4246,368.945523 C354.4246,368.945523 348.9046,363.075523 346.7636,360.605523 L346.7546,360.595523",
    id: "Stroke-87",
    stroke: "#1D1D1B",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.2543,367.115723 C338.2243,367.145723 338.2043,367.175723 338.1743,367.215723 C332.4143,374.365723 328.6943,388.514723 328.6943,388.514723 C328.6943,388.514723 326.3943,395.235723 327.4143,414.325723 C328.4243,433.425723 337.4643,451.045723 338.9833,457.315723 C340.5143,463.594723 341.3943,470.514723 341.2443,475.575723 C341.0143,482.855723 336.2043,499.685723 334.3843,502.365723",
    id: "Stroke-88",
    stroke: "#1D1D1B",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.4536,473.333523 C331.0796,505.696523 337.1976,514.563523 339.3376,530.819523 L338.4236,544.398523 C338.3556,547.044523 340.2656,549.328523 342.8816,549.729523 L347.1276,550.380523 C350.1026,550.835523 352.9166,552.029523 355.3106,553.853523 L360.0156,557.433523 C365.4476,561.567523 372.0076,563.956523 378.8266,564.283523 L383.7976,564.541523 C386.8346,564.657523 389.4526,563.464523 390.0326,561.588523 L390.3606,560.238523 C391.1316,557.073523 390.0556,553.744523 387.5776,551.629523 L367.8686,534.803523 C364.7066,531.644523 363.7236,528.758523 363.3606,524.303523 C366.3656,510.250523 370.5346,492.747523 370.6526,477.566523 C370.6526,477.566523 351.9456,482.444523 335.0606,473.017523 C334.8026,472.872523 334.4846,473.039523 334.4536,473.333523",
    id: "Fill-89",
    fill: "#FFAB05"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.4536,473.333523 C331.0796,505.696523 337.1976,514.563523 339.3376,530.819523 L338.4236,544.398523 C338.3556,547.044523 340.2656,549.328523 342.8816,549.729523 L347.1276,550.380523 C350.1026,550.835523 352.9166,552.029523 355.3106,553.853523 L360.0156,557.433523 C365.4476,561.567523 372.0076,563.956523 378.8266,564.283523 L383.7976,564.541523 C386.8346,564.657523 389.4526,563.464523 390.0326,561.588523 L390.3606,560.238523 C391.1316,557.073523 390.0556,553.744523 387.5776,551.629523 L367.8686,534.803523 C364.7066,531.644523 363.7236,528.758523 363.3606,524.303523 C366.3656,510.250523 370.5346,492.747523 370.6526,477.566523 C370.6526,477.566523 351.9456,482.444523 335.0606,473.017523 C334.8026,472.872523 334.4846,473.039523 334.4536,473.333523 Z",
    id: "Stroke-90",
    stroke: "#1D1D1B",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-93",
    transform: "translate(356.999100, 533.299323)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.6625,0.8926 C9.6625,0.8926 6.0405,0.4116 0.7875,3.1476",
    id: "Fill-91",
    fill: "#FFAB05"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.6625,0.8926 C9.6625,0.8926 6.0405,0.4116 0.7875,3.1476",
    id: "Stroke-92",
    stroke: "#1D1D1B",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M338.9301,541.094223 C338.8621,543.740223 340.7721,546.024223 343.3881,546.424223 L347.6331,547.074223 C350.6091,547.531223 353.4221,548.725223 355.8181,550.547223 L360.5211,554.128223 C365.9531,558.263223 372.5131,560.652223 379.3321,560.979223 L386.2221,561.310223 C388.0141,561.396223 389.6751,560.370223 390.4011,558.729223",
    id: "Stroke-94",
    stroke: "#1D1D1B",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.5893,536.305223 C357.5893,536.305223 362.2283,533.856223 366.1903,534.237223 L364.4433,530.137223 C364.4433,530.137223 359.6493,532.587223 357.5893,536.305223",
    id: "Fill-95",
    fill: "#1D1D1B",
    opacity: 0.300000012
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-98",
    transform: "translate(367.999100, 474.299323)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.6029,3.126 C2.6029,3.126 3.1529,1.254 0.4209,0.758",
    id: "Fill-96",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.6029,3.126 C2.6029,3.126 3.1529,1.254 0.4209,0.758",
    id: "Stroke-97",
    stroke: "#1D1D1B",
    strokeWidth: 1.5
  })), /*#__PURE__*/React.createElement("path", {
    d: "M369.809,486.425323 C369.809,486.425323 351.102,491.304323 334.217,481.875323",
    id: "Stroke-99",
    stroke: "#1D1D1B",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.6372,471.515123 C334.6372,471.515123 351.1192,478.907123 368.1162,474.414123 L368.6482,477.769123 C368.6482,477.769123 347.6922,480.895123 334.8062,472.572123",
    id: "Fill-100",
    fill: "#1D1D1B",
    opacity: 0.300000012
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.2446,475.575723 C341.2446,475.575723 337.5236,499.083723 342.4996,527.019723 C342.8386,528.924723 341.3446,530.694723 339.4126,530.814723 C339.3886,530.815723 339.3626,530.817723 339.3376,530.819723",
    id: "Stroke-101",
    stroke: "#1D1D1B",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.5268,458.875523 C257.1278,430.525523 265.2368,387.555523 282.6368,368.945523 C282.6368,368.945523 288.1578,363.075523 290.2978,360.605523 C284.8778,358.385523 279.1068,359.775523 273.7078,367.155523 C269.2078,373.295523 246.5668,409.905523 266.2668,457.015523 C266.5478,457.686523 266.8168,458.365523 267.0568,459.055523 L267.5268,458.875523 Z",
    id: "Fill-102",
    fill: "#708BE6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.477,466.275923 C285.607,465.405923 287.847,459.495923 286.498,453.075923 C285.137,446.645923 280.697,442.145923 276.578,443.014923 C272.447,443.884923 270.207,449.795923 271.557,456.225923 C272.917,462.645923 277.357,467.145923 281.477,466.275923 M290.297,360.605923 C293.307,361.835923 296.217,364.165923 298.887,367.214923 C304.647,374.365923 308.368,388.514923 308.368,388.514923 C308.368,388.514923 310.667,395.235923 309.647,414.325923 C308.637,433.424923 299.597,451.045923 298.078,457.315923 C296.547,463.594923 295.667,470.514923 295.817,475.575923 C296.047,482.855923 300.857,499.685923 302.677,502.365923 C302.377,504.045923 302.007,505.735923 301.538,507.435923 L270.248,504.165923 C267.067,487.915923 268.057,478.884923 268.847,471.804923 C269.337,467.455923 268.538,463.165923 267.057,459.054923 L267.527,458.875923 C257.127,430.525923 265.237,387.554923 282.637,368.945923 C282.637,368.945923 288.158,363.075923 290.297,360.605923",
    id: "Fill-103",
    fill: "#85A1F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.5776,443.015123 C272.4466,443.885123 270.2076,449.795123 271.5566,456.226123 C272.9176,462.646123 277.3566,467.146123 281.4766,466.276123 C285.6066,465.406123 287.8476,459.495123 286.4976,453.076123 C285.1376,446.646123 280.6966,442.146123 276.5776,443.015123",
    id: "Fill-104",
    fill: "#85A1F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.3676,388.515123 C308.3676,388.515123 310.6676,395.236123 309.6466,414.326123 C308.6376,433.425123 299.5966,451.045123 298.0776,457.316123 C296.5476,463.595123 295.6676,470.515123 295.8166,475.576123 C296.0476,482.856123 300.8566,499.686123 302.6776,502.366123 C304.3966,492.646123 303.5376,483.425123 302.8876,476.245123 C302.0376,466.745123 304.2366,457.765123 307.2076,448.705123 C317.5666,417.085123 311.8466,392.476123 310.5376,388.555123 C307.9366,380.755123 303.7976,372.795123 298.8876,367.215123 C304.6466,374.366123 308.3676,388.515123 308.3676,388.515123",
    id: "Fill-105",
    fill: "#708BE6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.5376,507.436023 C302.0076,505.736023 302.3776,504.045023 302.6776,502.366023 C304.3966,492.646023 303.5376,483.425023 302.8876,476.246023 C302.0376,466.746023 304.2366,457.765023 307.2076,448.706023 C317.5666,417.085023 311.8476,392.476023 310.5376,388.555023 C307.9366,380.755023 303.7976,372.795023 298.8876,367.215023 C296.2176,364.166023 293.3076,361.835023 290.2976,360.606023 C284.8776,358.385023 279.1066,359.776023 273.7076,367.156023 C269.2076,373.295023 246.5666,409.906023 266.2666,457.015023 C266.5476,457.686023 266.8166,458.366023 267.0576,459.055023 C268.5376,463.165023 269.3376,467.456023 268.8476,471.805023 C268.0576,478.885023 267.0666,487.915023 270.2476,504.165023",
    id: "Stroke-106",
    stroke: "#1D1D1B",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.4975,453.075723 C287.8475,459.495723 285.6065,465.405723 281.4765,466.275723 C277.3565,467.145723 272.9175,462.645723 271.5575,456.225723 C270.2075,449.795723 272.4465,443.885723 276.5775,443.014723 C280.6965,442.145723 285.1375,446.645723 286.4975,453.075723 Z",
    id: "Stroke-107",
    stroke: "#1D1D1B",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.5268,458.875523 C257.1278,430.525523 265.2368,387.555523 282.6368,368.945523 C282.6368,368.945523 288.1578,363.075523 290.2978,360.605523 L290.3068,360.595523",
    id: "Stroke-108",
    stroke: "#1D1D1B",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.8071,367.115723 C298.8371,367.145723 298.8571,367.175723 298.8871,367.215723 C304.6471,374.365723 308.3681,388.514723 308.3681,388.514723 C308.3681,388.514723 310.6671,395.235723 309.6471,414.325723 C308.6371,433.425723 299.5971,451.045723 298.0781,457.315723 C296.5471,463.594723 295.6671,470.514723 295.8171,475.575723 C296.0471,482.855723 300.8571,499.685723 302.6771,502.365723",
    id: "Stroke-109",
    stroke: "#1D1D1B",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.6079,473.333523 C305.9819,505.696523 299.8639,514.563523 297.7239,530.819523 L298.6379,544.398523 C298.7069,547.044523 296.7959,549.328523 294.1799,549.729523 L289.9339,550.380523 C286.9599,550.835523 284.1449,552.029523 281.7509,553.853523 L277.0459,557.433523 C271.6139,561.567523 265.0539,563.956523 258.2349,564.283523 L253.2639,564.541523 C250.2269,564.657523 247.6089,563.464523 247.0289,561.588523 L246.7009,560.238523 C245.9299,557.073523 247.0069,553.744523 249.4839,551.629523 L269.1929,534.803523 C272.3549,531.644523 273.3379,528.758523 273.7009,524.303523 C270.6959,510.250523 266.5269,492.747523 266.4089,477.566523 C266.4089,477.566523 285.1159,482.444523 302.0009,473.017523 C302.2589,472.872523 302.5769,473.039523 302.6079,473.333523",
    id: "Fill-110",
    fill: "#FFAB05"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.6079,473.333523 C305.9819,505.696523 299.8639,514.563523 297.7239,530.819523 L298.6379,544.398523 C298.7069,547.044523 296.7959,549.328523 294.1799,549.729523 L289.9339,550.380523 C286.9599,550.835523 284.1449,552.029523 281.7509,553.853523 L277.0459,557.433523 C271.6139,561.567523 265.0539,563.956523 258.2349,564.283523 L253.2639,564.541523 C250.2269,564.657523 247.6089,563.464523 247.0289,561.588523 L246.7009,560.238523 C245.9299,557.073523 247.0069,553.744523 249.4839,551.629523 L269.1929,534.803523 C272.3549,531.644523 273.3379,528.758523 273.7009,524.303523 C270.6959,510.250523 266.5269,492.747523 266.4089,477.566523 C266.4089,477.566523 285.1159,482.444523 302.0009,473.017523 C302.2589,472.872523 302.5769,473.039523 302.6079,473.333523 Z",
    id: "Stroke-111",
    stroke: "#1D1D1B",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-114",
    transform: "translate(269.999100, 533.299323)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.4008,0.8926 C0.4008,0.8926 4.0228,0.4116 9.2758,3.1476",
    id: "Fill-112",
    fill: "#FFAB05"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.4008,0.8926 C0.4008,0.8926 4.0228,0.4116 9.2758,3.1476",
    id: "Stroke-113",
    stroke: "#1D1D1B",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M298.1313,541.094223 C298.1993,543.740223 296.2893,546.024223 293.6733,546.424223 L289.4283,547.074223 C286.4523,547.531223 283.6393,548.725223 281.2433,550.547223 L276.5403,554.128223 C271.1083,558.263223 264.5483,560.652223 257.7293,560.979223 L250.8393,561.310223 C249.0473,561.396223 247.3863,560.370223 246.6603,558.729223",
    id: "Stroke-115",
    stroke: "#1D1D1B",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-118",
    transform: "translate(265.999100, 474.299323)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.4613,3.126 C0.4613,3.126 -0.0897,1.254 2.6423,0.758",
    id: "Fill-116",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.4613,3.126 C0.4613,3.126 -0.0897,1.254 2.6423,0.758",
    id: "Stroke-117",
    stroke: "#1D1D1B",
    strokeWidth: 1.5
  })), /*#__PURE__*/React.createElement("path", {
    d: "M267.2534,486.425323 C267.2534,486.425323 285.9594,491.304323 302.8454,481.875323",
    id: "Stroke-119",
    stroke: "#1D1D1B",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.4877,536.355023 C279.4877,536.355023 274.8477,533.905023 270.8867,534.287023 L272.6337,530.186023 C272.6337,530.186023 277.4277,532.637023 279.4877,536.355023",
    id: "Fill-120",
    fill: "#1D1D1B",
    opacity: 0.300000012
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.7934,475.577623 C295.7934,475.577623 299.5144,499.085623 294.5384,527.021623 C294.1984,528.926623 295.6934,530.696623 297.6244,530.816623 C297.6494,530.817623 297.6754,530.819623 297.7004,530.821623",
    id: "Stroke-121",
    stroke: "#1D1D1B",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.6518,471.515123 C302.6518,471.515123 285.0488,478.413123 269.1638,474.463123 L268.6408,477.769123 C268.6408,477.769123 289.5968,480.895123 302.4828,472.572123",
    id: "Fill-122",
    fill: "#1D1D1B",
    opacity: 0.300000012
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.8364,198.765123 C265.8364,198.765123 320.1244,181.678123 372.5144,198.765123 C372.5144,198.765123 355.7004,220.968123 318.6684,220.968123 C281.6364,220.968123 265.8364,198.765123 265.8364,198.765123",
    id: "Fill-123",
    fill: "#FFE4D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.8364,198.765123 C265.8364,198.765123 320.1244,181.678123 372.5144,198.765123 C372.5144,198.765123 355.7004,220.968123 318.6684,220.968123 C281.6364,220.968123 265.8364,198.765123 265.8364,198.765123 Z",
    id: "Stroke-124",
    stroke: "#1D1D1B",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.1684,185.837423 C333.6404,183.872423 331.0584,177.478423 320.5944,177.827423 C320.0854,177.844423 319.5674,177.856423 319.0434,177.867423 C313.5954,177.986423 307.4194,178.122423 305.2444,184.017423 C302.7134,190.877423 300.8324,203.656423 304.0524,208.816423 C306.6674,213.007423 312.8124,216.669423 319.4464,216.669423 C320.5224,216.669423 321.6144,216.572423 322.7034,216.366423 C331.1244,214.772423 333.6204,211.125423 334.7774,206.141423 C335.5644,202.749423 334.8614,188.418423 334.1684,185.837423",
    id: "Fill-125",
    fill: "#1D1D1B",
    opacity: 0.300000012
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.8042,193.923323 C288.0632,195.600323 294.1962,204.066323 315.5282,204.066323 L319.3272,204.066323 L323.1272,204.066323 C346.0862,204.066323 349.6782,195.932323 350.9882,193.681323",
    id: "Fill-126",
    fill: "#1D1D1B",
    opacity: 0.200000003
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-129",
    transform: "translate(290.999100, 137.299323)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.3724,0.8896 L16.7114,0.8896 C15.4444,0.8896 9.1364,1.7586 6.5714,10.3276 C4.1684,18.3576 0.0064,45.8196 0.8824,51.9306 C1.1124,53.5406 -0.7516,65.3276 24.9924,66.3046 L28.3724,66.3046",
    id: "Fill-127",
    fill: "#FFE4D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.3724,0.8896 L16.7114,0.8896 C15.4444,0.8896 9.1364,1.7586 6.5714,10.3276 C4.1684,18.3576 0.0064,45.8196 0.8824,51.9306 C1.1124,53.5406 -0.7516,65.3276 24.9924,66.3046 L28.3724,66.3046",
    id: "Stroke-128",
    stroke: "#1D1D1B",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-132",
    transform: "translate(318.999100, 137.299323)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.3724,0.8896 L12.0334,0.8896 C13.3014,0.8896 19.6084,1.7586 22.1734,10.3276 C24.5764,18.3576 28.7384,45.8196 27.8634,51.9306 C27.6334,53.5406 29.4974,65.3276 3.7524,66.3046 L0.3724,66.3046",
    id: "Fill-130",
    fill: "#FFE4D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.3724,0.8896 L12.0334,0.8896 C13.3014,0.8896 19.6084,1.7586 22.1734,10.3276 C24.5764,18.3576 28.7384,45.8196 27.8634,51.9306 C27.6334,53.5406 29.4974,65.3276 3.7524,66.3046 L0.3724,66.3046",
    id: "Stroke-131",
    stroke: "#1D1D1B",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M346.6547,186.502423 C346.4277,186.665423 346.1857,186.814423 345.9287,186.944423 C343.1407,188.373423 339.7217,187.272423 338.2937,184.482423 C336.8647,181.694423 337.9667,178.275423 340.7567,176.847423 C342.2967,176.058423 344.0287,176.040423 345.5107,176.653423",
    id: "Fill-133",
    fill: "#FFCBC9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.2309,186.502423 C292.4589,186.665423 292.7009,186.814423 292.9569,186.944423 C295.7459,188.373423 299.1639,187.272423 300.5919,184.482423 C302.0209,181.694423 300.9189,178.275423 298.1299,176.847423 C296.5899,176.058423 294.8579,176.040423 293.3749,176.653423",
    id: "Fill-134",
    fill: "#FFCBC9"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-137",
    transform: "translate(283.999100, 157.299323)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.5394,2.9922 C11.6294,2.1512 10.4354,1.4742 9.0534,1.0892 C5.3954,0.0682 1.8114,1.4712 1.0484,4.2222 C0.2844,6.9732 2.6304,10.0312 6.2874,11.0522 C8.3614,11.6312 10.4124,11.4302 11.9384,10.6452",
    id: "Fill-135",
    fill: "#FFE4D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5394,2.9922 C11.6294,2.1512 10.4354,1.4742 9.0534,1.0892 C5.3954,0.0682 1.8114,1.4712 1.0484,4.2222 C0.2844,6.9732 2.6304,10.0312 6.2874,11.0522 C8.3614,11.6312 10.4124,11.4302 11.9384,10.6452",
    id: "Stroke-136",
    stroke: "#1D1D1B",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M294.8608,163.879423 C295.2528,163.854423 295.5898,164.151423 295.6158,164.544423 C295.6408,164.937423 295.3438,165.275423 294.9528,165.301423 C294.5608,165.326423 294.2228,165.028423 294.1978,164.636423 C294.1728,164.243423 294.4688,163.904423 294.8608,163.879423",
    id: "Fill-138",
    fill: "#1D1D1B"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-141",
    transform: "translate(339.999100, 156.299323)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.8871,2.9922 C1.7981,2.1512 2.9921,1.4742 4.3741,1.0892 C8.0321,0.0682 11.6161,1.4712 12.3791,4.2222 C13.1431,6.9732 10.7971,10.0312 7.1401,11.0522 C5.0661,11.6312 3.0151,11.4302 1.4891,10.6452",
    id: "Fill-139",
    fill: "#FFE4D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.8871,2.9922 C1.7981,2.1512 2.9921,1.4742 4.3741,1.0892 C8.0321,0.0682 11.6161,1.4712 12.3791,4.2222 C13.1431,6.9732 10.7971,10.0312 7.1401,11.0522 C5.0661,11.6312 3.0151,11.4302 1.4891,10.6452",
    id: "Stroke-140",
    stroke: "#1D1D1B",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M342.5649,162.879423 C342.1729,162.854423 341.8359,163.151423 341.8099,163.544423 C341.7849,163.937423 342.0819,164.275423 342.4729,164.301423 C342.8649,164.326423 343.2029,164.028423 343.2279,163.636423 C343.2529,163.243423 342.9569,162.904423 342.5649,162.879423",
    id: "Fill-142",
    fill: "#1D1D1B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.5835,175.577623 C314.8405,175.760623 307.8665,175.321623 305.6275,181.280623 C303.1595,187.846623 301.2325,200.521623 304.3425,205.413623 C307.4525,210.306623 315.2185,213.996623 322.5725,212.629623 C330.8345,211.093623 333.1775,207.628623 334.2785,202.968623 C335.0465,199.724623 334.3275,185.459623 333.6635,183.035623 C332.8065,179.906623 329.5085,175.293623 320.5835,175.577623",
    id: "Fill-143",
    fill: "#FFAB05"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.5835,175.577623 C314.8405,175.760623 307.8665,175.321623 305.6275,181.280623 C303.1595,187.846623 301.2325,200.521623 304.3425,205.413623 C307.4525,210.306623 315.2185,213.996623 322.5725,212.629623 C330.8345,211.093623 333.1775,207.628623 334.2785,202.968623 C335.0465,199.724623 334.3275,185.459623 333.6635,183.035623 C332.8065,179.906623 329.5085,175.293623 320.5835,175.577623 Z",
    id: "Stroke-144",
    stroke: "#1D1D1B",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.1596,183.218223 C303.0686,188.781223 303.8886,197.522223 306.5246,201.666223 C309.1596,205.811223 315.7206,208.835223 321.9706,207.780223 C328.0176,206.758223 330.4146,203.815223 332.2426,199.590223 C333.5306,196.614223 334.6936,189.661223 333.9106,184.705223",
    id: "Stroke-145",
    stroke: "#1D1D1B",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.767,181.345223 C325.898,181.336223 326.017,181.429223 326.028,181.560223 C326.439,186.556223 323.704,190.880223 319.842,191.274223 C316.029,191.662223 312.174,188.465223 312.728,181.975223 C312.755,181.660223 313.043,181.437223 313.358,181.455223 C317.494,181.700223 321.631,181.647223 325.767,181.345223",
    id: "Fill-146",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.767,181.345223 C325.898,181.336223 326.017,181.429223 326.028,181.560223 C326.439,186.556223 323.704,190.880223 319.842,191.274223 C316.029,191.662223 312.174,188.465223 312.728,181.975223 C312.755,181.660223 313.043,181.437223 313.358,181.455223 C317.494,181.700223 321.631,181.647223 325.767,181.345223 Z",
    id: "Stroke-147",
    stroke: "#1D1D1B",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.8042,185.115723 C312.8042,185.115723 322.6412,184.340723 325.6642,185.519723 L325.6812,185.524723 C324.8342,188.695723 322.6282,191.042723 319.8302,191.327723 C316.6812,191.648723 313.5022,189.522723 312.8042,185.115723",
    id: "Fill-148",
    fill: "#1D1D1B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.8042,185.115723 C312.8042,185.115723 322.6412,184.340723 325.6642,185.519723 L325.6812,185.524723 C324.8342,188.695723 322.6282,191.042723 319.8302,191.327723 C316.6812,191.648723 313.5022,189.522723 312.8042,185.115723 Z",
    id: "Stroke-149",
    stroke: "#1D1D1B",
    strokeWidth: 0.75,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.7993,163.977023 C329.7453,164.051023 330.4603,164.307023 330.5233,165.949023 C330.5933,167.779023 330.3263,169.543023 330.2783,169.521023 C330.2783,169.521023 330.0803,171.096023 328.9203,171.334023 C327.7603,171.574023 326.8083,171.160023 326.7023,169.410023 C326.6113,167.895023 326.7103,166.790023 326.9623,165.534023 C327.1203,164.747023 327.8543,163.903023 328.7993,163.977023",
    id: "Fill-150",
    fill: "#1D1D1B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.437,166.436016 C320.262,166.439023 320.957,166.663023 320.914,168.314023 C320.871,169.965023 320.901,171.911023 320.901,171.911023 C320.901,171.911023 321.004,173.489023 320.012,173.815023 C319.02,174.142023 317.957,173.810023 317.963,172.048023 C317.968,170.764023 317.939,168.945023 317.942,168.137023 C317.945,167.330023 318.611,166.433023 319.437,166.436016",
    id: "Fill-151",
    fill: "#FE658C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.935,164.595223 C308.989,164.668223 308.274,164.925223 308.211,166.572223 C308.142,168.408223 308.41,170.177223 308.458,170.156223 C308.458,170.156223 308.655,171.735223 309.816,171.975223 C310.976,172.214223 311.928,171.799223 312.034,170.043223 C312.124,168.525223 312.025,167.417223 311.772,166.157223 C311.614,165.366223 310.88,164.521223 309.935,164.595223",
    id: "Fill-152",
    fill: "#1D1D1B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.4633,156.731923 C316.0063,156.778923 316.5543,156.877923 317.0283,157.160923 C317.4173,157.393923 317.7973,157.744923 317.9323,158.255923 C318.3073,159.673923 317.6633,160.826923 316.3173,161.030923 C314.9733,161.233923 310.6303,161.560923 308.8233,161.845923 C307.0173,162.131923 303.6733,162.865923 302.7123,161.845923 C301.7513,160.826923 301.9633,157.735923 305.7683,157.205923 C309.4683,156.689923 312.5273,156.476923 315.4633,156.731923",
    id: "Fill-153",
    fill: "#FFAB05"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.4633,156.731923 C316.0063,156.778923 316.5543,156.877923 317.0283,157.160923 C317.4173,157.393923 317.7973,157.744923 317.9323,158.255923 C318.3073,159.673923 317.6633,160.826923 316.3173,161.030923 C314.9733,161.233923 310.6303,161.560923 308.8233,161.845923 C307.0173,162.131923 303.6733,162.865923 302.7123,161.845923 C301.7513,160.826923 301.9633,157.735923 305.7683,157.205923 C309.4683,156.689923 312.5273,156.476923 315.4633,156.731923 Z",
    id: "Stroke-154",
    stroke: "#1D1D1B",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.5444,153.511223 C324.8734,153.141223 323.3174,153.372223 322.9124,155.047223 C322.5074,156.722223 322.9024,158.133223 324.9904,158.664223 C327.0784,159.195223 334.1764,161.176223 334.1764,161.176223 C334.1764,161.176223 337.0234,161.807223 337.5184,159.575223 C337.9124,157.794223 337.4944,156.618223 335.9994,156.015223 C334.5044,155.412223 327.3204,153.684223 326.5444,153.511223",
    id: "Fill-155",
    fill: "#FFAB05"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.5444,153.511223 C324.8734,153.141223 323.3174,153.372223 322.9124,155.047223 C322.5074,156.722223 322.9024,158.133223 324.9904,158.664223 C327.0784,159.195223 334.1764,161.176223 334.1764,161.176223 C334.1764,161.176223 337.0234,161.807223 337.5184,159.575223 C337.9124,157.794223 337.4944,156.618223 335.9994,156.015223 C334.5044,155.412223 327.3204,153.684223 326.5444,153.511223 Z",
    id: "Stroke-156",
    stroke: "#1D1D1B",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.3237,193.614723 C322.4277,193.970723 322.2417,194.643723 321.1327,194.969723 C319.8947,195.333723 319.0947,195.315723 318.7397,195.330723 C318.3847,195.343723 317.4707,195.325723 317.1127,194.848723 C316.8907,194.554723 316.9707,193.827723 318.1477,193.457723 C319.1657,193.137723 319.9347,192.997723 320.8337,192.914723 C321.3967,192.862723 322.1707,193.086723 322.3237,193.614723",
    id: "Fill-157",
    fill: "#1D1D1B"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-160",
    transform: "translate(297.999100, 118.299323)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.6615,16.625 C42.6615,16.625 42.0335,12.778 41.2755,9.925 C40.2665,6.126 36.7115,2.149 31.4795,1.816 L15.2265,1 C8.9685,0.602 5.2495,3.198 2.9785,8.048 C1.7395,10.696 0.9505,13.076 0.2855,17.303",
    id: "Fill-158",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.6615,16.625 C42.6615,16.625 42.0335,12.778 41.2755,9.925 C40.2665,6.126 36.7115,2.149 31.4795,1.816 L15.2265,1 C8.9685,0.602 5.2495,3.198 2.9785,8.048 C1.7395,10.696 0.9505,13.076 0.2855,17.303",
    id: "Stroke-159",
    stroke: "#1D1D1B",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M316.1694,141.716323 C316.0484,141.824323 315.8684,141.835323 315.7344,141.743323 C315.6074,141.660323 315.5464,141.505323 315.5824,141.358323 L317.2844,134.731323 L312.7674,134.731323 C312.5744,134.730323 312.4194,134.573323 312.4194,134.382323 C312.4194,134.279323 312.4654,134.182323 312.5434,134.116323 L322.8024,125.570323 C322.9254,125.482323 323.0924,125.482323 323.2154,125.570323 C323.3434,125.654323 323.4034,125.808323 323.3674,125.956323 L321.6664,132.556323 L326.1784,132.556323 C326.3704,132.557323 326.5254,132.713323 326.524405,132.904323 C326.524405,133.007323 326.4804,133.105323 326.4004,133.170323 L316.1694,141.716323 Z",
    id: "Fill-161",
    fill: "#FFAB05"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.1694,141.716323 C316.0484,141.824323 315.8684,141.835323 315.7344,141.743323 C315.6074,141.660323 315.5464,141.505323 315.5824,141.358323 L317.2844,134.731323 L312.7674,134.731323 C312.5744,134.730323 312.4194,134.573323 312.4194,134.382323 C312.4194,134.279323 312.4654,134.182323 312.5434,134.116323 L322.8024,125.570323 C322.9254,125.482323 323.0924,125.482323 323.2154,125.570323 C323.3434,125.654323 323.4034,125.808323 323.3674,125.956323 L321.6664,132.556323 L326.1784,132.556323 C326.3704,132.557323 326.5254,132.713323 326.524405,132.904323 C326.524405,133.007323 326.4804,133.105323 326.4004,133.170323 L316.1694,141.716323 Z",
    id: "Stroke-162",
    stroke: "#1D1D1B",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.7973,149.796423 C341.7973,149.796423 340.2013,149.089423 337.3413,148.585423 C330.6833,147.411423 317.1943,145.835423 301.9073,148.923423 C300.1863,149.271423 298.6113,149.739423 296.7693,150.495423 C296.7693,150.495423 293.9623,145.687423 293.3713,143.076423 C292.3173,139.992423 293.8143,136.151423 297.5643,135.700423 C311.6743,134.005423 331.9113,134.686423 343.5803,135.415423 C346.5693,135.602423 348.7593,137.096423 347.0493,141.539423 C345.3403,145.982423 341.7973,149.796423 341.7973,149.796423",
    id: "Fill-163",
    fill: "#FFAB05"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.7973,149.796423 C341.7973,149.796423 340.2013,149.089423 337.3413,148.585423 C330.6833,147.411423 317.1943,145.835423 301.9073,148.923423 C300.1863,149.271423 298.6113,149.739423 296.7693,150.495423 C296.7693,150.495423 293.9623,145.687423 293.3713,143.076423 C292.3173,139.992423 293.8143,136.151423 297.5643,135.700423 C311.6743,134.005423 331.9113,134.686423 343.5803,135.415423 C346.5693,135.602423 348.7593,137.096423 347.0493,141.539423 C345.3403,145.982423 341.7973,149.796423 341.7973,149.796423 Z",
    id: "Stroke-164",
    stroke: "#1D1D1B",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.9672,155.803223 C295.9672,155.803223 310.9342,147.749223 341.7972,150.380223 C341.7972,150.380223 323.1022,144.522223 297.8162,150.289223 L295.9672,155.803223 Z",
    id: "Fill-165",
    fill: "#1D1D1B",
    opacity: 0.200000003
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.7241,167.928223 C296.7241,167.928223 296.1291,170.609223 293.8281,171.900223 L293.8281,169.178223 C293.8281,169.178223 294.8021,169.298223 296.7241,167.928223",
    id: "Fill-166",
    fill: "#1D1D1B",
    opacity: 0.300000012
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.8276,167.311023 C340.8276,167.311023 342.0736,170.409023 345.1816,171.507023 L344.6686,168.242023 C344.6686,168.242023 343.4776,168.578023 340.8276,167.311023",
    id: "Fill-167",
    fill: "#1D1D1B",
    opacity: 0.300000012
  }), /*#__PURE__*/React.createElement("line", {
    x1: 318.6235,
    y1: 147.459523,
    x2: 318.6235,
    y2: 134.462523,
    id: "Stroke-168",
    stroke: "#1D1D1B",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.8139,240.905723 C426.9949,245.344723 425.0849,258.835723 414.4239,271.835723 C404.5039,270.195723 389.6839,280.755723 389.6839,280.755723 C389.6839,280.755723 378.9549,288.575723 361.4949,294.145723 L318.6249,293.855723 L274.1549,293.855723 C257.2239,288.315723 246.8649,280.755723 246.8649,280.755723 C246.8649,280.755723 235.2239,272.625723 223.2049,271.835723 C212.8749,258.875723 211.3839,245.455723 211.5349,241.025723 C213.4239,187.195723 265.3939,198.605723 265.3939,198.605723 C287.9149,216.884723 305.5039,220.965723 318.6649,220.965723 C331.8349,220.965723 348.2849,218.375723 371.9449,198.605723 C371.9449,198.605723 424.6739,189.304723 426.8139,240.905723",
    id: "Fill-169",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.684,280.755423 C389.684,280.755423 378.955,288.575423 361.495,294.146423 C351.855,297.226423 340.164,299.606423 327.105,299.606423 C327.105,299.606423 343.294,304.526423 369.814,297.455423 C373.054,296.585423 376.455,295.535423 379.995,294.276423 C381.995,293.575423 384.044,292.795423 386.134,291.945423 C399.285,286.606423 408.294,279.306423 414.424,271.835423 C404.504,270.195423 389.684,280.755423 389.684,280.755423",
    id: "Fill-170",
    fill: "#F1F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.0239,294.275923 C375.6039,311.585923 358.3649,319.945923 358.3649,319.945923 C358.3649,319.945923 352.4549,321.924923 348.3939,322.485923 C369.8139,315.094923 369.8139,297.455923 369.8139,297.455923 C373.0539,296.585923 376.4549,295.535923 379.9949,294.275923 L380.0239,294.275923 Z",
    id: "Fill-171",
    fill: "#F1F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.7338,338.535623 C331.5938,339.495623 324.5638,339.875623 318.7138,339.875623 L318.6738,339.875623 L318.6248,339.875623 C306.9148,339.875623 291.5138,337.514623 278.8838,332.965623 C278.8838,332.965623 276.3748,327.385623 278.9638,319.965623 C279.6648,320.205623 285.0748,321.965623 288.8538,322.485623 C267.4448,315.095623 267.4448,297.455623 267.4448,297.455623 L267.4448,297.435623 C290.6338,303.635623 305.9448,300.665623 309.4638,299.805623 C309.9738,299.685623 310.2338,299.605623 310.2338,299.605623 L327.1038,299.605623 C327.1038,299.605623 343.2948,304.525623 369.8138,297.455623 C369.8138,297.455623 369.8138,315.095623 348.3938,322.485623 C352.4548,321.925623 358.3648,319.945623 358.3648,319.945623 C361.3248,326.535623 359.4338,333.775623 359.4338,333.775623 C353.1248,336.055623 345.8748,337.575623 338.7338,338.535623",
    id: "Fill-172",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.0932,323.176323 C348.0932,323.176323 353.7912,325.249323 359.5902,325.396323 C359.5902,325.396323 358.7402,321.038323 358.0632,320.415323 C357.3862,319.792323 351.2462,323.007323 348.0932,323.176323",
    id: "Fill-173",
    fill: "#1D1D1B",
    opacity: 0.300000012
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.2368,323.176323 C289.2368,323.176323 283.5398,325.249323 277.7398,325.396323 C277.7398,325.396323 278.5908,321.038323 279.2668,320.415323 C279.9438,319.792323 286.0848,323.007323 289.2368,323.176323",
    id: "Fill-174",
    fill: "#1D1D1B",
    opacity: 0.300000012
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.2338,299.605923 C310.2338,299.605923 309.9738,299.685923 309.4638,299.804923 L309.4448,299.605923 C295.9638,299.605923 283.9548,297.065923 274.1548,293.855923 L318.6248,293.855923 L361.4948,294.145923 C351.8538,297.225923 340.1648,299.605923 327.1038,299.605923 L310.2338,299.605923 Z",
    id: "Fill-175",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.4448,297.455623 C267.4448,297.455623 267.4448,315.095623 288.8538,322.485623 C285.0748,321.965623 279.6648,320.205623 278.9648,319.965623 C278.9738,319.955623 278.9738,319.955623 278.9738,319.945623 C278.9738,319.945623 260.2548,311.965623 256.1438,293.855623 L256.1548,293.855623 C260.0938,295.295623 263.8648,296.476623 267.4448,297.435623 L267.4448,297.455623 Z",
    id: "Fill-176",
    fill: "#F1F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.4448,299.605923 C295.9648,299.605923 283.9548,297.065923 274.1538,293.855923 C257.2238,288.315923 246.8648,280.754923 246.8648,280.754923 C246.8648,280.754923 235.2238,272.625923 223.2048,271.834923 C229.1538,279.294923 238.0248,286.595923 251.1948,291.945923 C252.8748,292.625923 254.5248,293.265923 256.1438,293.855923 L256.1538,293.855923 C260.0938,295.294923 263.8648,296.475923 267.4448,297.435923 C290.6338,303.634923 305.9448,300.665923 309.4648,299.805923 L309.4448,299.605923 Z",
    id: "Fill-177",
    fill: "#F1F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.144,293.855923 C260.254,311.964923 278.974,319.945923 278.974,319.945923 C278.974,319.955923 278.974,319.955923 278.964,319.964923 C276.374,327.384923 278.884,332.964923 278.884,332.964923 C291.514,337.514923 306.915,339.875923 318.624,339.875923 L318.674,339.875923 L318.714,339.875923 C324.564,339.875923 331.594,339.495923 338.734,338.535923 C345.874,337.575923 353.124,336.054923 359.434,333.775923 C359.434,333.775923 361.325,326.535923 358.365,319.945923 C358.365,319.945923 375.604,311.585923 380.024,294.275923 L379.995,294.275923",
    id: "Stroke-178",
    stroke: "#1D1D1B",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.2338,299.605923 C310.2338,299.605923 309.9738,299.685923 309.4638,299.804923 C305.9448,300.665923 290.6338,303.634923 267.4448,297.435923 C263.8648,296.475923 260.0938,295.294923 256.1548,293.855923 L256.1438,293.855923 C254.5238,293.264923 252.8748,292.625923 251.1948,291.945923 C238.0238,286.594923 229.1548,279.294923 223.2048,271.834923 C212.8748,258.875923 211.3838,245.455923 211.5348,241.025923 C213.4238,187.195923 265.3938,198.605923 265.3938,198.605923 C287.9148,216.884923 305.5048,220.964923 318.6648,220.964923 C331.8348,220.964923 348.2848,218.375923 371.9448,198.605923 C371.9448,198.605923 424.6738,189.304923 426.8138,240.905923 C426.9948,245.344923 425.0848,258.834923 414.4238,271.834923 C408.2948,279.304923 399.2848,286.605923 386.1338,291.945923 C384.0448,292.794923 381.9948,293.575923 379.9948,294.275923 C376.4548,295.535923 373.0538,296.584923 369.8138,297.455923 C343.2948,304.525923 327.1038,299.605923 327.1038,299.605923",
    id: "Stroke-179",
    stroke: "#1D1D1B",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.3647,319.945823 C358.3647,319.945823 352.4547,321.924823 348.3937,322.485823",
    id: "Stroke-180",
    stroke: "#1D1D1B",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.8842,319.945823 C278.8842,319.945823 278.9142,319.955823 278.9642,319.965823 C279.6642,320.205823 285.0742,321.965823 288.8542,322.485823",
    id: "Stroke-181",
    stroke: "#1D1D1B",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 318.6245,
    y1: 339.875523,
    x2: 318.6245,
    y2: 318.245523,
    id: "Stroke-182",
    stroke: "#1D1D1B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.8139,297.455623 C369.8139,297.455623 369.8139,315.095623 348.3939,322.485623",
    id: "Stroke-183",
    stroke: "#1D1D1B",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.4448,297.455623 C267.4448,297.455623 267.4448,315.095623 288.8538,322.485623",
    id: "Stroke-184",
    stroke: "#1D1D1B",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.104,299.605923 C340.165,299.605923 351.854,297.225923 361.495,294.145923 C378.955,288.575923 389.684,280.754923 389.684,280.754923 C389.684,280.754923 404.504,270.195923 414.424,271.834923",
    id: "Stroke-185",
    stroke: "#1D1D1B",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.4448,299.605923 C295.9648,299.605923 283.9548,297.065923 274.1548,293.855923 C257.2238,288.315923 246.8648,280.754923 246.8648,280.754923 C246.8648,280.754923 235.2238,272.625923 223.2048,271.834923",
    id: "Stroke-186",
    stroke: "#1D1D1B",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.7407,198.604023 C281.3597,218.206023 305.5057,223.968023 318.6707,223.968023 C331.8367,223.968023 356.5647,218.713023 375.7307,198.604023",
    id: "Stroke-187",
    stroke: "#1D1D1B",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.1616,261.884323 C342.1616,274.859323 331.6446,285.375323 318.6706,285.375323 C305.6966,285.375323 295.1806,274.859323 295.1806,261.884323 C295.1806,248.910323 305.6966,238.394323 318.6706,238.394323 C331.6446,238.394323 342.1616,248.910323 342.1616,261.884323",
    id: "Fill-188",
    fill: "#1D1D1B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.351,260.872523 C341.351,273.398523 331.197,283.552523 318.67,283.552523 C306.145,283.552523 295.991,273.398523 295.991,260.872523 C295.991,248.347523 306.145,238.192523 318.67,238.192523 C331.197,238.192523 341.351,248.347523 341.351,260.872523",
    id: "Fill-189",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.351,260.872523 C341.351,273.398523 331.197,283.552523 318.67,283.552523 C306.145,283.552523 295.991,273.398523 295.991,260.872523 C295.991,248.347523 306.145,238.192523 318.67,238.192523 C331.197,238.192523 341.351,248.347523 341.351,260.872523 Z",
    id: "Stroke-190",
    stroke: "#1D1D1B",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 318.6235,
    y1: 290.467323,
    x2: 318.6235,
    y2: 276.803323,
    id: "Stroke-191",
    stroke: "#1D1D1B",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 318.6235,
    y1: 245.024923,
    x2: 318.6235,
    y2: 231.359923,
    id: "Stroke-192",
    stroke: "#1D1D1B",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.2299,271.711423 C314.0669,271.857423 313.8259,271.871423 313.6459,271.748423 C313.4739,271.636423 313.3919,271.428423 313.4409,271.229423 L315.7289,262.318423 L309.6549,262.318423 C309.3969,262.318423 309.1879,262.108423 309.1879,261.850423 C309.1889,261.712423 309.2499,261.581423 309.3549,261.493423 L323.1479,250.003423 C323.3139,249.883423 323.5379,249.883423 323.7039,250.003423 C323.8749,250.114423 323.9569,250.323423 323.9079,250.522423 L321.6199,259.396423 L327.6869,259.396423 C327.9449,259.396423 328.1539,259.606423 328.152904,259.864423 C328.152904,260.002423 328.0919,260.133423 327.9869,260.221423 L314.2299,271.711423 Z",
    id: "Fill-193",
    fill: "#FFAB05"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.2299,271.711423 C314.0669,271.857423 313.8259,271.871423 313.6459,271.748423 C313.4739,271.636423 313.3919,271.428423 313.4409,271.229423 L315.7289,262.318423 L309.6549,262.318423 C309.3969,262.318423 309.1879,262.108423 309.1879,261.850423 C309.1889,261.712423 309.2499,261.581423 309.3549,261.493423 L323.1479,250.003423 C323.3139,249.883423 323.5379,249.883423 323.7039,250.003423 C323.8749,250.114423 323.9569,250.323423 323.9079,250.522423 L321.6199,259.396423 L327.6869,259.396423 C327.9449,259.396423 328.1539,259.606423 328.152904,259.864423 C328.152904,260.002423 328.0919,260.133423 327.9869,260.221423 L314.2299,271.711423 Z",
    id: "Stroke-194",
    stroke: "#1D1D1B",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.6245,318.245623 C318.6245,318.245623 319.1735,334.315623 325.8495,336.717623 L318.6295,337.182623 L318.6245,318.245623 Z",
    id: "Fill-195",
    fill: "#1D1D1B",
    opacity: 0.300000012
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.5327,318.245623 C318.5327,318.245623 317.9837,334.315623 311.3087,336.717623 L318.5277,337.182623 L318.5327,318.245623 Z",
    id: "Fill-196",
    fill: "#1D1D1B",
    opacity: 0.300000012
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.6792,300.220223 C326.6792,300.220223 352.9312,310.501223 376.0882,303.061223 C376.0882,303.061223 379.7642,297.147223 379.9942,294.276223 C379.9942,294.276223 351.1792,303.657223 326.6792,300.220223",
    id: "Fill-197",
    fill: "#1D1D1B",
    opacity: 0.300000012
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.146,300.220223 C310.146,300.220223 283.895,310.501223 260.737,303.061223 C260.737,303.061223 257.061,297.147223 256.832,294.276223 C256.832,294.276223 285.646,303.657223 310.146,300.220223",
    id: "Fill-198",
    fill: "#1D1D1B",
    opacity: 0.300000012
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.7241,355.555223 C365.8841,359.526223 365.5541,363.915223 364.4541,368.635223 C364.4541,368.635223 361.1241,369.026223 356.3251,370.436223 C359.4841,366.295223 361.1441,361.205223 362.0041,356.535223 C363.1441,356.236223 364.2641,355.906223 365.3651,355.566223 L365.7241,355.555223 Z",
    id: "Fill-199",
    fill: "#708BE6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.2641,342.025923 C364.4641,345.585923 365.5351,350.174923 365.7241,355.554923 L365.3651,355.565923 C364.2641,355.905923 363.1441,356.235923 362.0041,356.535923 C363.3541,349.134923 362.6841,342.764923 362.6841,342.764923 L362.5641,342.165923 L363.2641,342.025923 Z",
    id: "Fill-200",
    fill: "#708BE6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.0747,341.476123 C363.1347,341.656123 363.2047,341.835123 363.2637,342.026123 L362.5637,342.165123 L361.9547,342.295123 C355.4837,343.715123 349.1347,344.726123 342.9837,345.425123 C341.3537,345.606123 339.9247,344.356123 339.8537,342.715123 L339.6347,336.906123 L339.6147,336.726123 C346.1147,336.165123 352.7847,335.226123 359.4337,333.776123 C359.4337,333.776123 361.3537,336.576123 363.0747,341.476123",
    id: "Fill-201",
    fill: "#85A1F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.8842,355.885323 C274.5442,348.505323 275.2142,342.175323 275.2142,342.175323 L275.8842,342.295323 C275.8842,342.295323 282.8242,344.026323 294.2042,345.325323 C295.8542,345.515323 297.3042,344.245323 297.3542,342.585323 L297.5242,335.965323 C298.7442,336.106323 300.0142,336.236323 301.3242,336.365323 L301.2742,336.906323 L301.2742,343.385323 C301.2742,344.875323 302.4242,346.106323 303.9142,346.215323 C312.4052,346.805323 322.4052,347.005323 333.2842,346.295323 C334.8042,346.196323 335.9642,344.896323 335.9142,343.385323 L335.7342,337.026323 C337.0142,336.946323 338.3142,336.845323 339.6142,336.726323 L339.6342,336.906323 L339.8542,342.715323 C339.9242,344.356323 341.3542,345.606323 342.9842,345.425323 C349.1342,344.726323 355.4842,343.715323 361.9542,342.295323 L362.5642,342.165323 L362.6842,342.765323 C362.6842,342.765323 363.3542,349.135323 362.0042,356.535323 C351.5542,359.365323 339.3942,360.825323 328.6842,361.385323 C328.5542,355.936323 324.0942,351.566323 318.6242,351.566323 C313.1742,351.566323 308.7242,355.896323 308.5542,361.316323 C298.0942,360.606323 286.3742,358.776323 275.8842,355.885323",
    id: "Fill-202",
    fill: "#85A1F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.0043,356.535623 C361.1443,361.205623 359.4833,366.295623 356.3243,370.435623 C348.9443,372.595623 338.0843,377.185623 330.4643,386.535623 C327.0943,390.675623 323.1243,393.255623 318.4643,393.255623 C316.0843,393.255623 313.7543,392.455623 311.6643,391.185623 C309.5743,389.915623 307.7243,388.175623 306.2643,386.275623 C301.3243,379.865623 296.1143,372.295623 281.3943,369.595623 C278.3343,365.485623 276.7243,360.475623 275.8843,355.885623 C286.3743,358.775623 298.0943,360.605623 308.5543,361.315623 C308.5443,361.425623 308.5443,361.535623 308.5443,361.645623 C308.5443,367.205623 313.0643,371.715623 318.6243,371.715623 C324.1843,371.715623 328.6943,367.205623 328.6943,361.645623 C328.6943,361.555623 328.6943,361.475623 328.6843,361.385623 C339.3943,360.825623 351.5543,359.365623 362.0043,356.535623",
    id: "Fill-203",
    fill: "#85A1F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.394,368.824723 C296.115,371.259723 301.325,374.958723 306.264,380.739723 C307.724,382.453723 309.575,384.022723 311.665,385.167723 C313.754,386.312723 316.084,387.034723 318.464,387.034723 C323.124,387.034723 327.094,384.707723 330.464,380.973723 C338.084,372.541723 348.945,371.529723 356.325,369.582723 C356.325,369.582723 343.382,373.402723 338.763,377.778723 C334.144,382.155723 332.425,383.683723 330.764,385.962723 C329.102,388.240723 324.426,392.946723 319.356,393.185723 C314.287,393.426723 309.273,390.009723 306.174,385.752723 C303.076,381.495723 297.428,372.807723 281.394,368.824723",
    id: "Fill-204",
    fill: "#1D1D1B",
    opacity: 0.300000012
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.9145,343.385323 C335.9645,344.896323 334.8045,346.196323 333.2845,346.295323 C322.4045,347.005323 312.4045,346.805323 303.9145,346.215323 C302.4245,346.106323 301.2735,344.875323 301.2735,343.385323 L301.2735,336.906323 L301.3245,336.365323 C310.9545,337.305323 322.9245,337.865323 335.7335,337.026323 L335.9145,343.385323 Z",
    id: "Fill-205",
    fill: "#85A1F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.3364,363.579623 C324.6094,363.536623 326.9694,360.232623 329.4154,360.103623 C329.4264,360.200623 329.4264,363.504623 329.4264,363.600623 C329.4264,369.564623 324.5884,374.401623 318.6244,374.401623 C312.6604,374.401623 307.8134,369.564623 307.8134,363.600623 C307.8134,363.482623 307.8134,360.146623 307.8234,360.028623 C310.2584,360.200623 312.6284,363.536623 314.9134,363.579623 L314.9134,363.622623 C314.9134,365.671623 316.5754,367.333623 318.6244,367.333623 C320.6734,367.333623 322.3364,365.671623 322.3364,363.622623 L322.3364,363.579623 Z",
    id: "Fill-206",
    fill: "#1D1D1B",
    opacity: 0.300000012
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.0844,361.625523 C324.2044,361.585523 326.4044,361.505523 328.6844,361.385523 C328.6944,361.476523 328.6944,361.555523 328.6944,361.646523 C328.6944,367.205523 324.1844,371.715523 318.6244,371.715523 C313.0634,371.715523 308.5444,367.205523 308.5444,361.646523 C308.5444,361.535523 308.5444,361.425523 308.5544,361.315523 C310.8244,361.476523 313.0344,361.585523 315.1644,361.625523 L315.1644,361.665523 C315.1644,363.575523 316.7144,365.125523 318.6244,365.125523 C320.5344,365.125523 322.0844,363.575523 322.0844,361.665523 L322.0844,361.625523 Z",
    id: "Fill-207",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.684,361.385323 C326.405,361.505323 324.205,361.585323 322.084,361.625323 C322.064,359.736323 320.524,358.205323 318.624,358.205323 C316.724,358.205323 315.184,359.736323 315.164,361.625323 C313.035,361.585323 310.825,361.476323 308.554,361.316323 C308.724,355.896323 313.174,351.566323 318.624,351.566323 C324.094,351.566323 328.554,355.936323 328.684,361.385323",
    id: "Fill-208",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.0844,361.625523 C320.7334,361.655523 319.4244,361.665523 318.1644,361.665523 L318.0634,361.665523 C317.1244,361.665523 316.1544,361.655523 315.1644,361.625523 C315.1844,359.735523 316.7244,358.205523 318.6244,358.205523 C320.5234,358.205523 322.0634,359.735523 322.0844,361.625523",
    id: "Fill-209",
    fill: "#FFAB05"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.6245,365.125523 C316.7145,365.125523 315.1645,363.575523 315.1645,361.665523 L315.1645,361.625523 C316.1545,361.655523 317.1245,361.665523 318.0635,361.665523 L318.1645,361.665523 C319.4245,361.665523 320.7335,361.655523 322.0845,361.625523 L322.0845,361.665523 C322.0845,363.575523 320.5345,365.125523 318.6245,365.125523",
    id: "Fill-210",
    fill: "#FFAB05"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.8842,355.885323 C276.7242,360.476323 278.3342,365.486323 281.3942,369.595323 C278.6242,369.095323 275.5142,368.755323 272.0042,368.635323 C272.0042,368.635323 270.7242,362.976323 271.6242,354.715323 L272.0042,354.755323 C273.2742,355.146323 274.5642,355.526323 275.8842,355.885323",
    id: "Fill-211",
    fill: "#708BE6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.5844,342.055223 C275.6544,339.106223 277.0634,336.045223 278.8844,332.965223 C278.8844,332.965223 286.1344,334.656223 297.5234,335.965223 L297.3544,342.585223 C297.3044,344.245223 295.8544,345.515223 294.2044,345.326223 C282.8244,344.026223 275.8844,342.295223 275.8844,342.295223 L275.2144,342.175223 L274.5844,342.055223 Z",
    id: "Fill-212",
    fill: "#85A1F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.5844,342.055223 L275.2144,342.175223 C275.2144,342.175223 274.5444,348.505223 275.8844,355.885223 C274.5634,355.526223 273.2734,355.146223 272.0044,354.755223 L271.6244,354.715223 C272.0444,350.936223 272.9144,346.625223 274.5844,342.055223",
    id: "Fill-213",
    fill: "#708BE6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.3237,370.436023 C348.1557,372.299023 337.3467,376.909023 330.4647,386.536023 C327.3597,390.878023 323.1247,393.255023 318.4647,393.255023 C316.0847,393.255023 313.7547,392.456023 311.6647,391.186023 C309.5747,389.915023 307.7237,388.175023 306.2637,386.276023 C301.3247,379.866023 296.1147,372.295023 281.3937,369.595023 C278.6247,369.095023 275.5137,368.755023 272.0047,368.635023 C272.0047,368.635023 270.7237,362.976023 271.6247,354.715023 C272.0447,350.936023 272.9147,346.625023 274.5847,342.055023 C275.6547,339.106023 277.0637,336.045023 278.8847,332.965023 C278.8847,332.965023 286.1347,334.656023 297.5237,335.965023 C298.7447,336.106023 300.0137,336.236023 301.3247,336.366023 C310.9547,337.305023 322.9247,337.866023 335.7337,337.026023 C337.0137,336.946023 338.3137,336.845023 339.6147,336.726023 C346.1147,336.165023 352.7847,335.226023 359.4337,333.776023 C359.4337,333.776023 361.3537,336.576023 363.0747,341.476023 C363.1347,341.656023 363.2047,341.835023 363.2637,342.026023 C364.4647,345.585023 365.5347,350.175023 365.7237,355.555023 C365.8847,359.526023 365.5537,363.915023 364.4547,368.635023 C364.4547,368.635023 361.1247,369.026023 356.3237,370.436023 Z",
    id: "Stroke-214",
    stroke: "#1D1D1B",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.2739,336.905823 L301.2739,343.384823 C301.2739,344.875823 302.4239,346.105823 303.9149,346.215823 C312.4049,346.804823 322.4049,347.005823 333.2849,346.295823 C334.8039,346.195823 335.9639,344.895823 335.9149,343.384823 L335.7339,337.025823",
    id: "Stroke-215",
    stroke: "#1D1D1B",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.684,361.385323 C339.394,360.825323 351.554,359.365323 362.004,356.535323 C363.144,356.236323 364.264,355.906323 365.365,355.566323",
    id: "Stroke-216",
    stroke: "#1D1D1B",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.5542,361.315923 C298.0942,360.605923 286.3742,358.775923 275.8842,355.884923 C274.5642,355.525923 273.2742,355.145923 272.0042,354.754923",
    id: "Stroke-217",
    stroke: "#1D1D1B",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.684,361.385323 C328.695,361.476323 328.695,361.555323 328.695,361.646323 C328.695,367.205323 324.184,371.715323 318.624,371.715323 C313.064,371.715323 308.544,367.205323 308.544,361.646323 C308.544,361.535323 308.544,361.425323 308.554,361.316323 C308.724,355.896323 313.174,351.566323 318.624,351.566323 C324.094,351.566323 328.554,355.936323 328.684,361.385323 Z",
    id: "Stroke-218",
    stroke: "#1D1D1B",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.0844,361.625523 L322.0844,361.665523 C322.0844,363.575523 320.5344,365.125523 318.6244,365.125523 C316.7144,365.125523 315.1644,363.575523 315.1644,361.665523 L315.1644,361.625523 C315.1844,359.735523 316.7244,358.205523 318.6244,358.205523 C320.5234,358.205523 322.0634,359.735523 322.0844,361.625523 Z",
    id: "Stroke-219",
    stroke: "#1D1D1B",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.5239,335.955623 L297.5239,335.965623 L297.3539,342.585623 C297.3039,344.245623 295.8539,345.515623 294.2049,345.325623 C282.8249,344.025623 275.0459,342.175623 275.0459,342.175623",
    id: "Stroke-220",
    stroke: "#1D1D1B",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.6342,336.905823 L339.8542,342.715823 C339.9242,344.355823 341.3542,345.605823 342.9842,345.425823 C349.1342,344.725823 356.0942,343.585823 362.5642,342.165823",
    id: "Stroke-221",
    stroke: "#1D1D1B",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 363.0747,
    y1: 341.476123,
    x2: 359.2947,
    y2: 334.316123,
    id: "Stroke-222",
    stroke: "#1D1D1B",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.2143,342.175323 C275.2143,342.175323 274.5443,348.505323 275.8843,355.885323 C276.7243,360.476323 278.3343,365.486323 281.3943,369.595323 C281.4643,369.696323 281.5343,369.795323 281.6143,369.896323",
    id: "Stroke-223",
    stroke: "#1D1D1B",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.5639,342.165523 C362.5639,342.165523 363.3539,349.135523 362.0039,356.535523 C361.1439,361.205523 359.4839,366.295523 356.3249,370.436523 C356.3139,370.455523 356.2939,370.465523 356.2849,370.485523",
    id: "Stroke-224",
    stroke: "#1D1D1B",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448.6743,266.820823 C450.5343,271.270823 456.4343,291.350823 423.5643,314.150823 C423.4543,314.240823 406.9863,325.642823 406.8663,325.732823 C401.8463,321.163823 392.7773,317.071823 385.7673,313.931823 C385.7673,313.931823 410.9263,295.537823 421.3343,292.620823 C423.3593,292.053823 423.9843,290.600823 423.8943,289.580823 C440.3143,285.410823 441.2443,276.580823 443.4543,270.370823 C444.2243,268.211823 444.7443,265.640823 444.9343,262.830823 C446.1443,263.930823 447.4343,265.270823 448.6743,266.820823",
    id: "Fill-225",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.7543,227.650923 C440.6543,234.470923 445.7443,250.810923 444.9343,262.830923 C442.8843,260.961923 441.0443,259.740923 439.9343,259.300923 L409.6243,288.030923 C409.0943,288.270923 408.5743,288.510923 408.0643,288.760923 C404.1243,287.530923 397.2443,285.300923 394.3743,278.711923 C391.1643,271.360923 392.1543,263.270923 397.4143,256.600923 C397.4243,256.600923 397.4343,256.590923 397.4343,256.590923 C399.0743,255.620923 400.7943,254.860923 402.5343,254.270923 L424.7543,227.650923 Z",
    id: "Fill-226",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.934,262.830623 C444.745,265.641623 444.224,268.211623 443.455,270.370623 C441.245,276.580623 440.314,285.410623 423.894,289.580623 C423.674,286.761623 416.984,284.501623 409.624,288.030623 L439.934,259.301623 C441.044,259.740623 442.884,260.961623 444.934,262.830623",
    id: "Fill-227",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.5639,314.150923 C456.4339,291.350923 450.5349,271.270923 448.6739,266.820923 C455.4239,275.160923 461.1249,289.510923 448.7239,306.110923 C443.6739,312.870923 418.9739,328.048923 411.8349,331.468923 C410.0249,329.529923 409.5369,328.163923 406.8669,325.732923 C406.9859,325.642923 423.4549,314.240923 423.5639,314.150923",
    id: "Fill-228",
    fill: "#F1F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.8667,325.732923 C405.5307,326.607923 404.1887,327.481923 402.8647,328.340923 C385.9547,330.150923 371.7747,327.740923 371.7747,327.740923 C371.7747,327.740923 371.9247,327.230923 372.2547,326.320923 C375.5447,322.414923 379.9687,318.269923 385.7667,313.931923 C394.0447,316.226923 401.0787,320.160923 406.8667,325.732923",
    id: "Fill-229",
    fill: "#FFE4D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.2944,358.751523 C408.1844,358.921523 407.9744,364.110523 404.5944,365.230523 C402.9834,365.751523 399.1444,366.230523 392.4644,365.721523 C385.8844,365.221523 377.2644,363.110523 369.6244,357.881523 L369.8944,357.471523 C367.2734,355.091523 365.2334,351.910523 364.4744,348.041523 L366.3944,347.641523 C368.3244,351.381523 381.9144,357.211523 388.4944,358.410523 C395.0844,359.601523 399.0444,359.160523 400.6934,358.801523 C400.8044,358.780523 400.9044,358.751523 401.0044,358.721523 L401.0144,358.721523 C401.7144,358.721523 402.4644,358.721523 403.2944,358.751523",
    id: "Fill-230",
    fill: "#FFE4D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.0747,352.221223 C404.7637,352.870223 404.2047,357.721223 401.0137,358.721223 L401.0047,358.721223 C397.5847,358.741223 395.2047,358.950223 388.7637,357.450223 C388.7847,355.641223 387.7147,354.231223 385.7847,353.131223 C387.0637,352.341223 387.2847,351.041223 387.1747,349.901223 C389.5847,350.681223 391.3647,351.111223 392.8847,351.381223 C392.9247,351.381223 392.9647,351.391223 392.9947,351.401223 C394.1647,351.631223 395.0637,351.731223 395.6937,351.751223 L395.7047,351.751223 C397.0447,351.891223 398.3847,351.981223 400.0747,352.221223",
    id: "Fill-231",
    fill: "#FFE4D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.4145,256.601123 C392.1545,263.271123 391.1645,271.361123 394.3745,278.711123 C397.2445,285.301123 404.1245,287.531123 408.0635,288.761123 C406.2845,289.611123 404.5845,290.501123 402.9745,291.431123 C385.5745,288.411123 383.7545,265.141123 396.7045,257.031123 C396.9345,256.881123 397.1745,256.741123 397.4145,256.601123",
    id: "Fill-232",
    fill: "#F1F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.7143,346.190923 C400.6043,347.660923 399.0043,351.791923 395.9843,351.760923 C395.8943,351.760923 395.8043,351.760923 395.7043,351.751923 L395.6933,351.751923 C394.8343,351.670923 393.9643,351.560923 392.9943,351.400923 C392.9643,351.390923 392.9243,351.380923 392.8843,351.380923 C391.3943,351.070923 389.4743,350.541923 387.1443,349.610923 C386.9843,348.520923 386.5443,347.640923 386.5443,347.640923 C386.8243,347.390923 387.3043,347.010923 387.9643,346.530923 C388.7843,345.930923 389.8843,345.170923 391.2343,344.260923 C393.0843,345.010923 394.5643,345.370923 396.7143,346.190923",
    id: "Fill-233",
    fill: "#FFE4D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.6245,288.030723 C409.0945,288.270723 408.5745,288.510723 408.0635,288.760723 C406.2845,289.610723 404.5845,290.501723 402.9745,291.430723 C397.2645,294.700723 392.5235,298.400723 388.6145,302.150723 C389.5845,301.331723 390.4345,300.610723 391.1345,300.010723 C392.2645,299.041723 376.5995,311.950723 378.0695,312.190723 C381.3595,312.730723 382.2335,312.857723 385.3335,314.257723 C385.3335,314.257723 403.0965,300.924723 421.3345,292.620723 C423.2475,291.749723 423.9835,290.600723 423.8945,289.581723 C423.6745,286.760723 416.9835,284.501723 409.6245,288.030723",
    id: "Fill-234",
    fill: "#F1F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.9946,351.400923 C393.9646,351.560923 394.8346,351.671923 395.6936,351.751923 C395.0636,351.730923 394.1646,351.630923 392.9946,351.400923",
    id: "Fill-235",
    fill: "#FFE4D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.8657,325.732923 C405.5317,326.607923 404.1887,327.481923 402.8647,328.340923 C394.1147,334.001923 386.1247,339.001923 386.1247,339.001923 C386.8647,340.310923 387.3347,341.470923 387.6037,342.470923 C388.3447,345.001923 387.9147,346.461923 387.9147,346.461923 L387.9647,346.530923 C388.7847,345.930923 389.8847,345.170923 391.2337,344.260923 C395.6937,341.268923 402.8977,336.722923 411.8347,331.468923",
    id: "Fill-236",
    fill: "#E8D1C8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.4946,358.410623 C381.9146,357.211623 368.3246,351.381623 366.3936,347.640623 L385.7546,349.431623 C386.2546,349.600623 386.7236,349.761623 387.1746,349.900623 C387.2846,351.041623 387.0636,352.341623 385.7846,353.131623 C387.7146,354.230623 388.7846,355.640623 388.7646,357.450623 C395.2046,358.950623 397.5846,358.740623 401.0046,358.721623 C400.9046,358.751623 400.8046,358.780623 400.6936,358.801623 C399.0446,359.160623 395.0846,359.600623 388.4946,358.410623",
    id: "Fill-237",
    fill: "#FFE4D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.9145,346.461423 L387.9645,346.530423 C387.3045,347.011423 386.8245,347.391423 386.5445,347.641423 C386.5445,347.641423 386.9835,348.521423 387.1435,349.610423 C386.7645,349.461423 386.3645,349.301423 385.9545,349.120423 L385.3745,341.150423 C386.1935,341.660423 386.9345,342.101423 387.6035,342.471423 C388.3445,345.001423 387.9145,346.461423 387.9145,346.461423",
    id: "Fill-238",
    fill: "#FFE4D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.7543,349.431223 L366.3943,347.641223 L364.4743,348.041223 C363.3343,342.211223 365.1143,334.821223 372.2543,326.321223 C371.9243,327.231223 371.7743,327.741223 371.7743,327.741223 C371.7743,327.741223 385.9543,330.151223 402.8643,328.341223 C394.1143,334.001223 386.1243,339.001223 386.1243,339.001223 C386.8643,340.311223 387.3343,341.471223 387.6043,342.471223 C386.9343,342.101223 386.1933,341.660223 385.3743,341.151223 L385.9543,349.120223 C386.3643,349.301223 386.7643,349.461223 387.1443,349.611223 C387.1543,349.711223 387.1743,349.801223 387.1743,349.901223 C386.7243,349.761223 386.2543,349.601223 385.7543,349.431223",
    id: "Fill-239",
    fill: "#FFE4D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.5776,312.190923 C372.9596,316.795923 368.3976,322.058923 365.6036,327.260923 C361.5946,334.751923 361.1036,343.251923 362.2046,347.640923 C363.0546,351.020923 366.1146,355.440923 369.3246,357.680923 C369.4246,357.751923 369.5236,357.820923 369.6246,357.880923 L369.8936,357.470923 C367.2736,355.090923 365.2336,351.910923 364.4736,348.041923 C363.3346,342.211923 365.1146,334.820923 372.2546,326.320923 C375.5446,322.413923 379.9696,318.270923 385.7666,313.931923",
    id: "Fill-240",
    fill: "#E8D1C8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.1245,234.801323 C390.1245,234.801323 398.2445,243.941323 397.4345,256.580323",
    id: "Stroke-241",
    stroke: "#1D1D1B",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.0346,248.080623 C388.0346,248.080623 393.5346,251.310623 395.1836,257.881623",
    id: "Stroke-242",
    stroke: "#1D1D1B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.894,203.001423 C404.894,203.001423 397.604,203.171423 392.415,209.261423",
    id: "Stroke-243",
    stroke: "#1D1D1B",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.434,256.591323 C399.075,255.620323 400.794,254.861323 402.535,254.271323",
    id: "Stroke-244",
    stroke: "#1D1D1B",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.9741,291.431123 C385.5751,288.410123 383.7541,265.141123 396.7041,257.031123 C396.9341,256.881123 397.1741,256.741123 397.4141,256.601123",
    id: "Stroke-245",
    stroke: "#1D1D1B",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.9223,227.648923 C440.8223,234.468923 445.7443,250.810923 444.9343,262.830923",
    id: "Stroke-246",
    stroke: "#1D1D1B",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.434,256.580623 L397.434,256.591623 C397.434,256.591623 397.424,256.601623 397.414,256.601623 C392.155,263.270623 391.164,271.360623 394.374,278.711623 C397.245,285.301623 404.124,287.530623 408.064,288.761623",
    id: "Stroke-247",
    stroke: "#1D1D1B",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.3178,331.773923 C418.4088,327.891923 443.1188,312.418923 448.7238,306.110923 C462.4708,290.643923 455.4238,275.160923 448.6738,266.820923 C447.4338,265.270923 446.1438,263.930923 444.9338,262.830923 C442.8838,260.960923 441.0448,259.740923 439.9338,259.300923",
    id: "Stroke-248",
    stroke: "#1D1D1B",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.6245,288.030723 C409.0945,288.270723 408.5745,288.510723 408.0635,288.760723 C406.2845,289.610723 404.5845,290.500723 402.9745,291.430723 C397.3275,294.328723 386.3365,303.487723 377.5775,312.190723",
    id: "Stroke-249",
    stroke: "#1D1D1B",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448.2446,265.900923 C448.2446,265.900923 448.4246,266.220923 448.6746,266.820923 C450.5346,271.270923 457.8516,291.882923 423.5636,314.150923",
    id: "Stroke-250",
    stroke: "#1D1D1B",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.767,313.932123 C385.767,313.932123 401.561,301.272123 421.334,292.620123 C423.26,291.779123 423.984,290.601123 423.894,289.580123 C423.674,286.761123 416.984,284.501123 409.624,288.031123",
    id: "Stroke-251",
    stroke: "#1D1D1B",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.8842,351.381323 C391.3942,351.070323 389.4742,350.541323 387.1442,349.610323",
    id: "Stroke-252",
    stroke: "#1D1D1B",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.2338,344.261223 C393.0848,345.011223 394.5638,345.370223 396.7138,346.191223 C400.6038,347.660223 399.0048,351.791223 395.9838,351.761223 C395.8938,351.761223 395.8038,351.761223 395.7048,351.751223",
    id: "Stroke-253",
    stroke: "#1D1D1B",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.1743,349.900923 C389.5843,350.680923 391.3643,351.110923 392.8843,351.380923 C392.9243,351.380923 392.9643,351.390923 392.9943,351.400923 C393.9643,351.560923 394.8343,351.671923 395.6943,351.751923 L395.7043,351.751923 C397.0443,351.890923 398.3843,351.980923 400.0743,352.220923 C404.7643,352.870923 404.2043,357.720923 401.0143,358.720923",
    id: "Stroke-254",
    stroke: "#1D1D1B",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.8344,331.469223 C402.8974,336.723223 395.6934,341.269223 391.2334,344.261223 C389.8844,345.171223 388.7844,345.931223 387.9644,346.531223 C387.3044,347.011223 386.8244,347.391223 386.5444,347.641223 C386.5444,347.641223 386.9834,348.521223 387.1444,349.611223 C387.1544,349.711223 387.1744,349.801223 387.1744,349.901223 C387.2844,351.041223 387.0634,352.341223 385.7844,353.131223 C387.7144,354.231223 388.7844,355.641223 388.7644,357.450223 C395.2044,358.950223 397.5844,358.740223 401.0044,358.721223 L401.0144,358.721223 C401.7144,358.721223 402.4644,358.721223 403.2944,358.751223 C408.1844,358.921223 407.9744,364.111223 404.5944,365.231223 C402.9834,365.751223 399.1444,366.231223 392.4644,365.721223 C385.8844,365.221223 377.2644,363.111223 369.6244,357.881223 C369.5234,357.821223 369.4244,357.751223 369.3244,357.681223 C366.1144,355.441223 363.0544,351.021223 362.2044,347.641223 C361.1044,343.251223 361.5944,334.751223 365.6044,327.261223 C368.3974,322.059223 372.9594,316.796223 377.5774,312.191223 C391.7504,314.407223 403.5964,320.182223 411.8344,331.469223 Z",
    id: "Stroke-255",
    stroke: "#1D1D1B",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.9145,346.461423 C387.9145,346.461423 388.3445,345.001423 387.6035,342.471423 C387.3345,341.471423 386.8645,340.311423 386.1245,339.001423 C386.1245,339.001423 394.1145,334.001423 402.8645,328.341423 C410.8535,323.160423 419.4835,317.421423 423.2335,314.421423 C423.3535,314.330423 423.4545,314.240423 423.5635,314.150423",
    id: "Stroke-256",
    stroke: "#1D1D1B",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.894,357.471223 C367.274,355.091223 365.234,351.910223 364.474,348.041223 C363.334,342.211223 365.115,334.821223 372.254,326.321223 C375.544,322.413223 379.969,318.271223 385.767,313.932223",
    id: "Stroke-257",
    stroke: "#1D1D1B",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.0249,358.566923 C395.1349,356.326923 394.0539,354.574923 392.1289,353.473923 C392.8119,352.914923 393.2189,352.100923 393.4039,351.466923 C393.4929,350.797923 393.4829,350.146923 393.3329,349.523923 L397.3119,346.456923 L391.3539,344.665923 L386.8339,347.639923 L387.5089,350.538923 L386.6429,353.262923 L388.3759,355.333923 L389.2419,357.170923 L395.0249,358.566923 Z",
    id: "Fill-258",
    fill: "#1D1D1B",
    opacity: 0.300000012
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.6206,237.747523 C425.6206,237.747523 426.0336,230.604523 425.3576,228.519523 L430.7376,231.195523 C430.7376,231.195523 428.5276,236.439523 425.6206,237.747523",
    id: "Fill-259",
    fill: "#1D1D1B",
    opacity: 0.300000012
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439.5297,258.660623 C439.5297,258.660623 443.9777,260.916623 444.9967,262.055623 L445.2707,257.875623 C445.2707,257.875623 441.3377,257.367623 439.5297,258.660623",
    id: "Fill-260",
    fill: "#1D1D1B",
    opacity: 0.300000012
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.4711,248.563923 C387.4711,248.563923 391.5521,253.282923 391.5521,260.837923 L395.1631,257.552923 C395.1631,257.552923 395.2731,253.880923 387.4711,248.563923",
    id: "Fill-261",
    fill: "#1D1D1B",
    opacity: 0.300000012
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-264",
    transform: "translate(423.999100, 227.299323)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.5541,9.8096 C1.5541,9.8096 2.3981,5.5426 0.9231,0.3496",
    id: "Fill-262",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.5541,9.8096 C1.5541,9.8096 2.3981,5.5426 0.9231,0.3496",
    id: "Stroke-263",
    stroke: "#1D1D1B",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M189.5483,266.820823 C187.6883,271.270823 181.7873,291.350823 214.6573,314.150823 C214.7683,314.240823 231.2363,325.642823 231.3563,325.733823 C236.3763,321.163823 245.4453,317.071823 252.4553,313.931823 C252.4553,313.931823 226.3883,295.882823 216.8883,292.620823 C214.9003,291.937823 214.2373,290.600823 214.3273,289.580823 C197.9073,285.410823 196.9783,276.580823 194.7683,270.370823 C193.9973,268.211823 193.4783,265.640823 193.2873,262.830823 C192.0773,263.930823 190.7873,265.270823 189.5483,266.820823",
    id: "Fill-265",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.4682,227.650923 C197.5682,234.470923 192.4782,250.810923 193.2872,262.830923 C195.3372,260.961923 197.1782,259.740923 198.2872,259.300923 L228.5982,288.030923 C229.1272,288.270923 229.6482,288.510923 230.1572,288.760923 C234.0982,287.530923 240.9782,285.300923 243.8482,278.711923 C247.0582,271.360923 246.0682,263.270923 240.8082,256.600923 C240.7982,256.600923 240.7872,256.590923 240.7872,256.590923 C239.1482,255.620923 237.4282,254.860923 235.6882,254.270923 L213.4682,227.650923 Z",
    id: "Fill-266",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.2876,262.830623 C193.4776,265.641623 193.9976,268.211623 194.7676,270.370623 C196.9776,276.580623 197.9076,285.410623 214.3276,289.580623 C214.5486,286.761623 221.2376,284.501623 228.5986,288.030623 L198.2876,259.301623 C197.1786,259.740623 195.3376,260.961623 193.2876,262.830623",
    id: "Fill-267",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.6577,314.150923 C181.7877,291.350923 187.6877,271.270923 189.5487,266.820923 C182.7987,275.160923 177.0977,289.510923 189.4977,306.110923 C194.5487,312.870923 219.2477,328.048923 226.3877,331.468923 C228.1977,329.529923 228.6857,328.163923 231.3557,325.733923 C231.2357,325.642923 214.7677,314.240923 214.6577,314.150923",
    id: "Fill-268",
    fill: "#F1F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.3559,325.733923 C232.6909,326.607923 234.0339,327.481923 235.3579,328.340923 C252.2679,330.150923 266.4479,327.740923 266.4479,327.740923 C266.4479,327.740923 266.2979,327.230923 265.9679,326.320923 C262.6779,322.414923 258.2529,318.270923 252.4559,313.931923 C244.1769,316.226923 237.1439,320.160923 231.3559,325.733923",
    id: "Fill-269",
    fill: "#FFE4D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.9282,358.751523 C230.0372,358.921523 230.2472,364.110523 233.6272,365.230523 C235.2382,365.751523 239.0772,366.230523 245.7582,365.721523 C252.3372,365.221523 260.9572,363.110523 268.5982,357.881523 L268.3272,357.471523 C270.9482,355.091523 272.9882,351.910523 273.7472,348.041523 L271.8272,347.641523 C269.8982,351.381523 256.3082,357.211523 249.7282,358.410523 C243.1382,359.601523 239.1782,359.160523 237.5282,358.801523 C237.4172,358.780523 237.3182,358.751523 237.2182,358.721523 L237.2072,358.721523 C236.5082,358.721523 235.7582,358.721523 234.9282,358.751523",
    id: "Fill-270",
    fill: "#FFE4D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.1479,352.221223 C233.4579,352.870223 234.0179,357.721223 237.2079,358.721223 L237.2179,358.721223 C240.6379,358.741223 243.0179,358.950223 249.4579,357.450223 C249.4379,355.641223 250.5079,354.231223 252.4379,353.131223 C251.1579,352.341223 250.9379,351.041223 251.0479,349.901223 C248.6379,350.681223 246.8579,351.111223 245.3369,351.381223 C245.2979,351.381223 245.2579,351.391223 245.2279,351.401223 C244.0579,351.631223 243.1579,351.731223 242.5279,351.751223 L242.5179,351.751223 C241.1779,351.891223 239.8369,351.981223 238.1479,352.221223",
    id: "Fill-271",
    fill: "#FFE4D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.8081,256.601123 C246.0681,263.271123 247.0581,271.361123 243.8481,278.711123 C240.9781,285.301123 234.0981,287.531123 230.1581,288.761123 C231.9381,289.611123 233.6381,290.501123 235.2471,291.431123 C252.6481,288.411123 254.4681,265.141123 241.5181,257.031123 C241.2871,256.881123 241.0481,256.741123 240.8081,256.601123",
    id: "Fill-272",
    fill: "#F1F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.5083,346.190923 C237.6173,347.660923 239.2183,351.791923 242.2373,351.760923 C242.3273,351.760923 242.4173,351.760923 242.5183,351.751923 L242.5283,351.751923 C243.3883,351.670923 244.2583,351.560923 245.2283,351.400923 C245.2583,351.390923 245.2983,351.380923 245.3373,351.380923 C246.8273,351.070923 248.7473,350.541923 251.0773,349.610923 C251.2373,348.520923 251.6783,347.640923 251.6783,347.640923 C251.3983,347.390923 250.9173,347.010923 250.2583,346.530923 C249.4383,345.930923 248.3373,345.170923 246.9873,344.260923 C245.1383,345.010923 243.6573,345.370923 241.5083,346.190923",
    id: "Fill-273",
    fill: "#FFE4D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.5981,288.030723 C229.1281,288.270723 229.6481,288.510723 230.1581,288.760723 C231.9381,289.610723 233.6381,290.501723 235.2471,291.430723 C240.9571,294.700723 245.6981,298.400723 249.6081,302.150723 C248.6381,301.331723 247.7871,300.610723 247.0881,300.010723 C245.9571,299.041723 261.6221,311.950723 260.1531,312.190723 C256.8631,312.730723 255.9881,312.857723 252.8881,314.257723 C252.8881,314.257723 235.1261,300.924723 216.8881,292.620723 C214.9751,291.749723 214.2381,290.600723 214.3271,289.581723 C214.5481,286.760723 221.2381,284.501723 228.5981,288.030723",
    id: "Fill-274",
    fill: "#F1F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.228,351.400923 C244.258,351.560923 243.388,351.671923 242.528,351.751923 C243.158,351.730923 244.058,351.630923 245.228,351.400923",
    id: "Fill-275",
    fill: "#FFE4D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.3559,325.732923 C232.6909,326.607923 234.0329,327.481923 235.3579,328.340923 C244.1079,334.001923 252.0979,339.001923 252.0979,339.001923 C251.3579,340.310923 250.8879,341.470923 250.6179,342.470923 C249.8779,345.001923 250.3079,346.461923 250.3079,346.461923 L250.2579,346.530923 C249.4379,345.930923 248.3379,345.170923 246.9879,344.260923 C242.5279,341.268923 235.3249,336.722923 226.3879,331.468923",
    id: "Fill-276",
    fill: "#E8D1C8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.728,358.410623 C256.308,357.211623 269.898,351.381623 271.828,347.640623 L252.468,349.431623 C251.968,349.600623 251.498,349.761623 251.048,349.900623 C250.938,351.041623 251.158,352.341623 252.438,353.131623 C250.508,354.230623 249.438,355.640623 249.457,357.450623 C243.018,358.950623 240.638,358.740623 237.218,358.721623 C237.318,358.751623 237.417,358.780623 237.528,358.801623 C239.178,359.160623 243.138,359.600623 249.728,358.410623",
    id: "Fill-277",
    fill: "#FFE4D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.3081,346.461423 L250.2581,346.530423 C250.9171,347.011423 251.3981,347.391423 251.6781,347.641423 C251.6781,347.641423 251.2381,348.521423 251.0781,349.610423 C251.4571,349.461423 251.8581,349.301423 252.2681,349.120423 L252.8481,341.150423 C252.0281,341.660423 251.2871,342.101423 250.6181,342.471423 C249.8771,345.001423 250.3081,346.461423 250.3081,346.461423",
    id: "Fill-278",
    fill: "#FFE4D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.4682,349.431223 L271.8272,347.641223 L273.7472,348.041223 C274.8882,342.211223 273.1082,334.821223 265.9682,326.321223 C266.2982,327.231223 266.4472,327.741223 266.4472,327.741223 C266.4472,327.741223 252.2682,330.151223 235.3582,328.341223 C244.1082,334.001223 252.0982,339.001223 252.0982,339.001223 C251.3582,340.311223 250.8882,341.471223 250.6172,342.471223 C251.2872,342.101223 252.0282,341.660223 252.8482,341.151223 L252.2682,349.120223 C251.8582,349.301223 251.4572,349.461223 251.0772,349.611223 C251.0682,349.711223 251.0482,349.801223 251.0482,349.901223 C251.4972,349.761223 251.9682,349.601223 252.4682,349.431223",
    id: "Fill-279",
    fill: "#FFE4D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.645,312.190923 C265.263,316.795923 269.824,322.058923 272.618,327.260923 C276.628,334.751923 277.118,343.251923 276.018,347.640923 C275.168,351.020923 272.108,355.440923 268.898,357.680923 C268.798,357.751923 268.698,357.820923 268.598,357.880923 L268.328,357.470923 C270.948,355.090923 272.988,351.910923 273.748,348.041923 C274.888,342.211923 273.108,334.820923 265.968,326.320923 C262.677,322.413923 258.253,318.270923 252.456,313.931923",
    id: "Fill-280",
    fill: "#E8D1C8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.0981,234.801323 C248.0981,234.801323 239.9781,243.941323 240.7871,256.580323",
    id: "Stroke-281",
    stroke: "#1D1D1B",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.188,248.080623 C250.188,248.080623 244.688,251.310623 243.038,257.881623",
    id: "Stroke-282",
    stroke: "#1D1D1B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.2544,203.001423 C232.2544,203.001423 239.5444,203.171423 244.7334,209.261423",
    id: "Stroke-283",
    stroke: "#1D1D1B",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.7876,256.591323 C239.1476,255.620323 237.4286,254.861323 235.6876,254.271323",
    id: "Stroke-284",
    stroke: "#1D1D1B",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.2475,291.431123 C252.6475,288.410123 254.4685,265.141123 241.5185,257.031123 C241.2875,256.881123 241.0485,256.741123 240.8085,256.601123",
    id: "Stroke-285",
    stroke: "#1D1D1B",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.2993,227.648923 C197.4003,234.468923 192.4783,250.810923 193.2873,262.830923",
    id: "Stroke-286",
    stroke: "#1D1D1B",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.7876,256.580623 L240.7876,256.591623 C240.7876,256.591623 240.7986,256.601623 240.8086,256.601623 C246.0676,263.270623 247.0586,271.360623 243.8486,278.711623 C240.9776,285.301623 234.0986,287.530623 230.1576,288.761623",
    id: "Stroke-287",
    stroke: "#1D1D1B",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.9048,331.773923 C219.8128,327.891923 194.5488,312.870923 189.4978,306.110923 C177.0978,289.510923 182.7988,275.160923 189.5488,266.820923 C190.7878,265.270923 192.0778,263.930923 193.2878,262.830923 C195.3378,260.960923 197.1778,259.740923 198.2878,259.300923",
    id: "Stroke-288",
    stroke: "#1D1D1B",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.5981,288.030723 C229.1271,288.270723 229.6481,288.510723 230.1581,288.760723 C231.9381,289.610723 233.6381,290.501723 235.2481,291.430723 C240.8941,294.328723 251.8851,303.487723 260.6451,312.190723",
    id: "Stroke-289",
    stroke: "#1D1D1B",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.978,265.900923 C189.978,265.900923 189.798,266.220923 189.548,266.820923 C187.688,271.270923 181.788,291.350923 214.658,314.150923",
    id: "Stroke-290",
    stroke: "#1D1D1B",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.4555,313.932123 C252.4555,313.932123 236.6615,301.272123 216.8885,292.620123 C214.9625,291.779123 214.2375,290.601123 214.3275,289.580123 C214.5485,286.761123 221.2375,284.501123 228.5985,288.031123",
    id: "Stroke-291",
    stroke: "#1D1D1B",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.3374,351.381323 C246.8274,351.070323 248.7474,350.541323 251.0774,349.610323",
    id: "Stroke-292",
    stroke: "#1D1D1B",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.9878,344.261223 C245.1378,345.011223 243.6578,345.370223 241.5088,346.191223 C237.6178,347.660223 239.2178,351.791223 242.2378,351.761223 C242.3278,351.761223 242.4178,351.761223 242.5178,351.751223",
    id: "Stroke-293",
    stroke: "#1D1D1B",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.0483,349.900923 C248.6383,350.680923 246.8583,351.110923 245.3373,351.380923 C245.2983,351.380923 245.2583,351.390923 245.2283,351.400923 C244.2583,351.560923 243.3883,351.671923 242.5273,351.751923 L242.5183,351.751923 C241.1783,351.890923 239.8373,351.980923 238.1483,352.220923 C233.4573,352.870923 234.0183,357.720923 237.2073,358.720923",
    id: "Stroke-294",
    stroke: "#1D1D1B",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.3882,331.469223 C235.3252,336.723223 242.5282,341.269223 246.9882,344.261223 C248.3372,345.171223 249.4382,345.931223 250.2582,346.531223 C250.9172,347.011223 251.3982,347.391223 251.6782,347.641223 C251.6782,347.641223 251.2382,348.521223 251.0772,349.611223 C251.0682,349.711223 251.0482,349.801223 251.0482,349.901223 C250.9382,351.041223 251.1582,352.341223 252.4382,353.131223 C250.5082,354.231223 249.4382,355.641223 249.4572,357.450223 C243.0182,358.950223 240.6382,358.740223 237.2182,358.721223 L237.2072,358.721223 C236.5082,358.721223 235.7582,358.721223 234.9282,358.751223 C230.0372,358.921223 230.2472,364.111223 233.6272,365.231223 C235.2382,365.751223 239.0772,366.231223 245.7582,365.721223 C252.3372,365.221223 260.9572,363.111223 268.5982,357.881223 C268.6982,357.821223 268.7982,357.751223 268.8982,357.681223 C272.1082,355.441223 275.1672,351.021223 276.0182,347.641223 C277.1172,343.251223 276.6272,334.751223 272.6172,327.261223 C269.8242,322.059223 265.2632,316.796223 260.6452,312.191223 C246.4722,314.407223 234.6262,320.182223 226.3882,331.469223 Z",
    id: "Stroke-295",
    stroke: "#1D1D1B",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.3081,346.461423 C250.3081,346.461423 249.8771,345.001423 250.6181,342.471423 C250.8881,341.471423 251.3581,340.311423 252.0981,339.001423 C252.0981,339.001423 244.1081,334.001423 235.3581,328.341423 C227.3681,323.160423 218.7381,317.421423 214.9881,314.421423 C214.8681,314.330423 214.7681,314.240423 214.6581,314.150423",
    id: "Stroke-296",
    stroke: "#1D1D1B",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.3276,357.471223 C270.9476,355.091223 272.9876,351.910223 273.7476,348.041223 C274.8886,342.211223 273.1076,334.821223 265.9686,326.321223 C262.6776,322.413223 258.2536,318.271223 252.4556,313.932223",
    id: "Stroke-297",
    stroke: "#1D1D1B",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.1967,358.566923 C243.0867,356.326923 244.1687,354.574923 246.0937,353.473923 C245.4107,352.914923 245.0027,352.100923 244.8177,351.466923 C244.7297,350.797923 244.7397,350.146923 244.8887,349.523923 L240.9107,346.456923 L246.8687,344.665923 L251.3887,347.639923 L250.7137,350.538923 L251.5787,353.262923 L249.8467,355.333923 L248.9807,357.170923 L243.1967,358.566923 Z",
    id: "Fill-298",
    fill: "#1D1D1B",
    opacity: 0.300000012
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.601,237.747523 C212.601,237.747523 212.188,230.604523 212.864,228.519523 L207.484,231.195523 C207.484,231.195523 209.694,236.439523 212.601,237.747523",
    id: "Fill-299",
    fill: "#1D1D1B",
    opacity: 0.300000012
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.6919,258.660623 C198.6919,258.660623 194.2449,260.916623 193.2259,262.055623 L192.9509,257.875623 C192.9509,257.875623 196.8849,257.367623 198.6919,258.660623",
    id: "Fill-300",
    fill: "#1D1D1B",
    opacity: 0.300000012
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.7514,248.563923 C250.7514,248.563923 246.6694,253.282923 246.6694,260.837923 L243.0594,257.552923 C243.0594,257.552923 242.9494,253.880923 250.7514,248.563923",
    id: "Fill-301",
    fill: "#1D1D1B",
    opacity: 0.300000012
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-304",
    transform: "translate(211.999100, 227.299323)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.6693,9.8096 C0.6693,9.8096 -0.1737,5.5426 1.3003,0.3496",
    id: "Fill-302",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.6693,9.8096 C0.6693,9.8096 -0.1737,5.5426 1.3003,0.3496",
    id: "Stroke-303",
    stroke: "#1D1D1B",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M260.6215,312.810123 C260.6215,312.810123 239.3275,317.120123 230.2015,332.977123 L227.0205,331.119123 C227.0205,331.119123 240.3965,314.128123 260.6215,312.810123",
    id: "Fill-305",
    fill: "#1D1D1B",
    opacity: 0.300000012
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.02,235.569823 C340.197,239.823823 346.562,249.117823 346.562,259.897823",
    id: "Stroke-306",
    stroke: "#1D1D1B",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.352,286.225123 C296.175,281.972123 289.81,272.678123 289.81,261.898123",
    id: "Stroke-307",
    stroke: "#1D1D1B",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.7954,187.238823 C401.7284,188.042823 426.0144,193.172823 433.3244,219.681823",
    id: "Stroke-308",
    stroke: "#1D1D1B",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.853,187.238823 C233.92,188.042823 209.634,193.172823 202.324,219.681823",
    id: "Stroke-309",
    stroke: "#1D1D1B",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLuke);
export default __webpack_public_path__ + "static/media/luke.534f9954737d87550301946ebe109081.svg";
export { ForwardRef as ReactComponent };